export default {
  common: {
    save: 'Kaydet',
    cancel: 'İptal',
    ok: 'Tamam',
    copied: 'Kopyalandı',
    selectAllLabel: 'Tümünü Seç',
    submit: 'Gönder',
    logout: 'Çıkış Yap',
    skip: 'Atla',
    viewMore: 'Daha fazla göster',
    viewLess: 'Daha az göster',
    changeLanguage: 'Dili değiştir',
    areYouSure: 'Emin misiniz?',
    done: 'Tamamlandı',
    error: 'Hata',
    close: 'Kapat',
    noResultsFound: 'Sonuç Bulunamadı',
    typeToSearch: 'Aramak için bir şeyler yazın!',
    typeToSearchPlaceholder: 'Aramak için yazın',
    active: 'Aktif',
    edit: 'Düzenle',
    updatedSuccessfully: 'Başarıyla güncellendi',
    success: 'Başarılı',
    addedSuccessfully: 'Başarıyla eklendi',
    date: 'Tarih',
    user: 'Kullanıcı',
    new: 'Yeni',
    delete: 'Sil',
    cash: 'Nakit',
    deletedSuccessfully: 'Başarıyla silindi',
    back: 'Geri',
    inactive: 'Pasif',
    all: 'Tümü',
    add: 'Ekle',
    create: 'Oluştur',
    update: 'Güncelle',
    reset: 'Sıfırla',
    editQuestion: 'düzenle?',
    search: 'Ara',
    select: 'Seç',
    filterColon: 'Filtre:',
    showResultLabel: 'Göster',
    resultLabel: 'Sonuç',
    totalResultLabel: 'Toplam Sonuç {count}',
    selectedCountLabel: '{count} seçildi',
    of: '/',
    canceledStatus: 'İptal Edildi',
    refundedStatus: 'İade Edildi',
    mobileSource: 'Mobil',
    webSource: 'Web',
    adminSource: 'Yönetim',
    warning: 'Uyarı',
    yes: 'Evet',
    no: 'Hayır',
    example: 'ör. {value}'
  },
  columns: {
    id: 'ID',
    item: 'Ürün',
    itemCode: 'Ürün Kodu',
    customer: 'Müşteri',
    name: 'İsim',
    email: 'E-posta',
    phoneNumber: 'Telefon Numarası',
    itemName: 'Ürün Adı',
    brand: 'Marka',
    url: 'URL',
    image: 'Resim',
    dateTime: 'Tarih ve Saat',
    status: 'Durum',
    statuses: 'Durumlar',
    checkBoxColumn: 'Onay Kutusu',
    warehouse: 'Depo',
    branch: 'Şube',
    role: 'Rol',
    summary: 'Özet',
    shipping: 'Gönderim',
    total: 'Toplam',
    qty: 'Miktar',
    size: 'Boyut',
    price: 'Fiyat',
    logo: 'Logo',
    defaultImage: 'Varsayılan Resim',
    country: 'Ülke',
    currency: 'Para Birimi',
    prefix: 'Önek',
    transportationTypes: 'Taşıma Türleri',
    city: 'Şehir',
    street: 'Sokak',
    code: 'Kod',
    houseNumber: 'Ev Numarası',
    estimateDays: 'Tahmini Gün',
    actions: 'İşlemler',
    stateProvince: 'Eyalet - İl',
    flagCode: 'Bayrak Kodu',
    customCode: 'Özel Kod',
    qr: 'QR',
    customerId: 'Müşteri ID',
    phone: 'Telefon',
    headQuarter: 'Merkez Şube',
    type: 'Tür',
    purchaseNote: 'Satın Alma Notu',
    bank: 'Banka',
    invoiceNo: 'Fatura No.',
    orderId: 'Sipariş No',
    productName: 'Ürün Adı',
    quantity: 'Miktar',
    note: 'Not',
    qrId: 'Qr ID',
    payment: 'Ödeme',
    orderInfo: 'Sipariş Bilgisi',
    itemDetails: 'Ürün Detayları',
    product: 'Ürün',
    statusLocation: 'Durum ve Konum',
    pricing: 'Fiyatlandırma',
    datePayment: 'Tarih ve Ödeme',
    invoiceInfo: 'Fatura Bilgisi',
    shipmentCosts: 'Gönderi Maliyetleri',
    cleared: 'Temizlendi',
    purchaseDate: 'Satın Alma Tarihi',
    warehouseDate: 'Depo Tarihi',
    bankName: 'Banka Adı',
    actualCost: 'Gerçek Maliyet',
    purchaseCost: 'Satın Alma Maliyeti',
    totalAmount: 'Toplam Tutar',
    purchasedBy: 'Satın Alan',
    refundNumber: 'İade Numarası',
    refundNote: 'İade Notu',
    discount: 'İndirim',
    weight: 'Ağırlık',
    deliveryPrice: 'Teslimat Ücreti',
    nationalTax: 'Ulusal Vergi',
    totalRefunded: 'Toplam İade',
    refundStatus: 'İade Durumu',
    trackNumber: 'Takip Numarası',
    orderNumber: 'Sipariş Numarası',
    createDate: 'Oluşturulma Tarihi',
    caseId: 'Vaka No',
    caseOrderId: 'Sipariş ID',
    createdBy: 'Oluşturan',
    customerPhone: 'Müşteri Telefonu',
    sentBy: 'Gönderen',
    deadline: 'Son Tarih',
    attachedInvoices: 'Ekli Faturalar',
    customerPhone2: 'Müşteri Telefonu 2',
    defaultLocation: 'Varsayılan Konum',
    totalPrice: 'Toplam Fiyat',
    orderHash: 'Sipariş #',
    volume: 'Hacim',
    handlingFee: 'İşlem Ücreti',
    shipment: 'Gönderi',
    tax: 'Vergi',
    amount: 'Tutar',
    paidAmount: 'Ödenen Tutar',
    remaining: 'Kalan',
    outOffice: 'Ofis Dışı',
    owner: 'Sahip',
    receivedDate: 'Teslim Alma Tarihi',
    receivedAmount: 'Alınan Tutar',
    createdAt: 'Oluşturulma Tarihi',
    updatedAt: 'Güncellenme Tarihi',
    checkBox: 'Onay kutusu',
    deliveryAddress: 'Teslimat Adresi',
    generatedBy: 'Oluşturan',
    dateFilterByLabel: 'Tarih Filtreleme Ölçütü',
    selectedSuffix: 'seçildi',
    orderStatus: 'Sipariş Durumu',
    productUrl: "Ürün URL'si",
    transactionDate: 'İşlem Tarihi',
    staffName: 'Personel Adı',
    action: 'İşlem',
    exRate: 'Döviz Kuru',
    paymentMethod: 'Ödeme Yöntemi',
    logDate: 'Kayıt Tarihi',
    cid: 'Müşteri No',
    subscription: 'Abonelik',
    rateLog: 'Kur Kaydı',
    paidVia: 'Ödeme Yöntemi',
    title: 'Başlık',
    order: 'Sıra',
    question: 'Soru',
    answer: 'Cevap',
    coupon: 'Kupon',
    expireDate: 'Son Kullanma Tarihi',
    percentage: 'Yüzde',
    nameArabic: 'İsim (Arapça)',
    nameKurdish: 'İsim (Kürtçe)',
    reasonEnglish: 'Neden (İngilizce)',
    reasonArabic: 'Neden (Arapça)',
    reasonKurdish: 'Neden (Kürtçe)',
    shipzoneFee: 'Shipzone Ücreti',
    handlingFeeAir: 'İşlem Ücreti (Hava)',
    handlingFeeSea: 'İşlem Ücreti (Deniz)',
    itemPriceAir: 'Ürün Fiyatı (Hava)',
    itemPriceSea: 'Ürün Fiyatı (Deniz)',
    itemPriceLand: 'Ürün Fiyatı (Kara)',
    localDelivery: 'Yerel Teslimat',
    default: 'Varsayılan',
    netPrice: 'Net fiyat',
    transportationType: 'Taşıma Türü',
    ordersStatus: 'Sipariş Durumu',
    postalCode: 'Posta Kodu',
    customerName: 'Müşteri Adı',
    customerNote: 'Müşteri Notu',
    phoneNumber2: 'Telefon Numarası 2',
    governorate: 'İl',
    address: 'Adres',
    credit: 'Bakiye',
    shipOnly: 'Sadece Gönderim',
    cancelReason: 'İptal Nedeni',
    description: 'Açıklama',
    verified: 'Doğrulandı',
    unverified: 'Doğrulanmadı',
    verifyFilterLabel: 'Doğrulama Filtresi',
    staff: 'Personel',
    balance: 'Bakiye',
    initialBalance: 'Başlangıç Bakiyesi',
    debit: 'Borç',
    transactionType: 'İşlem Türü',
    source: 'Kaynak',
    sourceId: 'Kaynak No',
    orderType: 'Sipariş Türü',
    orderTypeName: 'Sipariş Türü Adı',
    phone2: 'Telefon2',
    receivedDeliveryAmount: 'Alınan Teslimat Tutarı',
    preview: 'Önizleme',
    linkUrl: 'Bağlantı (URL)',
    qrCode: 'QR Kod',
    domain: 'Alan Adı',
    platform: 'Platform',
    invoiceNumber: 'Fatura Numarası',
    refundBy: 'İade Eden',
    confirmDate: 'Onay Tarihi',
    fromDate: 'Başlangıç Tarihi',
    toDate: 'Bitiş Tarihi',
    buyCost: 'Satın alma maliyeti',
    intShipping: 'Uluslararası Kargo',
    usdPrice: 'USD Fiyatı',
    tlPrice: 'TL Fiyatı',
    exchangeDate: 'Kur Tarihi',
    book: 'Defter',
    fromBank: 'Gönderen Banka',
    toBank: 'Alıcı Banka',
    expenseAmount: 'Gider Tutarı',
    iqdSell: 'IQD Satış',
    iqdBuy: 'IQD Alış',
    tlSell: 'TL Satış',
    tlBuy: 'TL Alış',
    aedSell: 'AED Satış',
    aedBuy: 'AED Alış',
    cnySell: 'CNY Satış',
    cnyBuy: 'CNY Alış',
    gbpSell: 'GBP Satış',
    gbpBuy: 'GBP Alış',
    eurSell: 'EUR Satış',
    eurBuy: 'EUR Alış',
    expenseType: 'Gider Türü',
    supplierInvoiceNo: 'Tedarikçi Fatura No.',
    supplier: 'Tedarikçi',
    expenseDate: 'Gider Tarihi',
    noAbbreviation: 'No'
  },
  orders: {
    newOrdersTitle: 'Yeni Siparişler',
    pendingAnswerOrdersTitle: 'Yanıt Bekleyen Siparişler',
    processedOrdersTitle: 'İşlenmiş Siparişler',
    canceledOrdersTitle: 'İptal Edilmiş Siparişler',
    processOrderTooltip: 'Siparişi İşle',
    approveThisOrderTooltip: 'Bu Siparişi Onayla',
    returnToNewOrderTooltip: 'Yeni Siparişlere Geri Döndür',
    returnToShipOnlyTooltip: 'Sadece Sevkiyata Geri Döndür',
    errorOccurredProcessingOrder: 'Bu sipariş işlenirken bir hata oluştu',
    errorOccurredSubmittingOrders: 'Siparişler gönderilirken bir hata oluştu',
    couldNotFetchOrderDetails: 'Sipariş detayları alınamadı',
    failedToCancelOrder: 'Sipariş iptal edilemedi',
    sumOfSelectedOrdersLabel: 'Seçilen siparişlerin toplamı',
    failedToSendOrdersToIntShipment: 'Siparişler Uluslararası Sevkiyata gönderilemedi',
    failedToSendOrdersToBranchDelivery: 'Siparişler Şube Teslimatına gönderilemedi',
    failedToUnclearOrders: 'Siparişlerin temizliği kaldırılamadı',
    failedToMarkOrdersAsDelivered: 'Siparişler teslim edildi olarak işaretlenemedi',
    missingQrCodeForMessage: 'QR kodu eksik: {list}. Diğerleri başarıyla teslim edildi — bunlar için bir QR kodu oluşturup tekrar deneyin.',
    customerHasLoanMustPayMessage: 'Bu müşterinin ({name}) borcu var ve en az ${amount} ödemesi gerekiyor',
    returnToProcessedOrderTooltip: 'İşlenmiş Siparişlere Geri Döndür',
    ordersReturnedToNewOrderSection: 'Siparişler yeni sipariş bölümüne geri döndürüldü',
    orderUpdatedTitle: 'Sipariş Güncellendi',
    pleaseSelectOrderToPurchase: 'Lütfen satın almak için bir sipariş seçin',
    pleaseRefreshPageAndTryAgain: 'Lütfen sayfayı yenileyip tekrar deneyin',
    pleaseCheckOrderToApprove: 'Lütfen onaylamak için en az bir sipariş seçin',
    onceConfirmedAllApproved: 'Onaylandıktan sonra, işaretlenen tüm siparişler onaylanacaktır',
    viewOrderInvoiceConfirm: 'Bu sipariş faturasını görmek ister misiniz?',
    pleaseSelectOrderToDelete: 'Lütfen silmek için en az bir sipariş seçin',
    deleteSelectedCanceledOrdersConfirm: 'Seçilen tüm iptal edilmiş siparişler silinsin mi? Bu ekrandan geri alınamaz.',
    permanentlyDeleteTitle: 'Kalıcı olarak silinsin mi?',
    permanentlyDeleteCanceledOrdersConfirm: 'Bu, seçilen iptal edilmiş siparişleri veritabanından tamamen kaldırır — "Seçilen Siparişleri Sil"in aksine, bu geri alınamaz. Müşterinin işlem geçmişi ve bakiyesi etkilenmez.',
    undoCancelOrderConfirm: 'Sipariş İptalini Geri Al, siparişi önceki duruma geri yükleyecektir.',
    warehouseDeliveredOrdersTitle: 'Depoya Teslim Edilen Siparişler',
    allOrdersTitle: 'Tüm Siparişler',
    deliveredToErbilOrdersTitle: "Erbil'e Teslim Edilen Siparişler",
    purchasedOrdersTitle: 'Satın Alınan Siparişler',
    approvedOrdersTitle: 'Onaylanmış Siparişler',
    internationalShipmentOrdersTitle: 'Uluslararası Gönderi Siparişleri',
    pendingToBranchOrdersTitle: 'Şubeye Gönderilmeyi Bekleyen Siparişler',
    refundedOrdersTitle: 'İade Edilmiş Siparişler',
    customerDeliveredOrdersTitle: 'Müşteriye Teslim Edilen Siparişler',
    exportableOrdersTitle: 'İhraç Edilebilir Siparişler',
    warehousePassedOrdersTitle: 'Depo Tarihi Geçen Siparişler',
    purchaseHistoryTitle: 'Satın Alma Geçmişi',
    viewShippingInvoiceTooltip: 'Gönderim Faturasını Görüntüle',
    generateQrCodeTooltip: 'QR Kod Oluştur',
    generateInvoiceTooltip: 'Fatura Oluştur',
    moveToDamageTooltip: 'Hasarlıya Taşı',
    moveToReturnTooltip: 'İadeye Taşı',
    sendToCustomerTooltip: 'Müşteriye Gönder',
    copyToNewOrderTooltip: 'Yeni Siparişe Kopyala',
    refundThisOrderTooltip: 'Bu Siparişi İade Et',
    addOrderNumberTooltip: 'Sipariş Numarası Ekle',
    orderNumberAddedSuccessfully: 'Sipariş numarası başarıyla eklendi',
    addWarehouseDateTooltip: 'Depo tarihi ekle',
    purchaseThisOrderTooltip: 'Bu Siparişi Satın Al',
    addBarcodeTooltip: 'Barkod Ekle',
    deliverToPendingToBranchTooltip: 'Şubeye gönderilmeyi bekleyene teslim et',
    sendToBranchDeliveryTooltip: 'Şube Teslimatına Gönder',
    deliverToBranchTooltip: 'Şubeye teslim et',
    pleaseSelectOrderOrCustomer: 'Lütfen en az bir sipariş veya müşteri seçin!',
    selectedDifferentCustomers: 'Farklı müşteriler seçtiniz',
    someOrdersAlreadyInvoiced: 'Seçilen bazı siparişler zaten faturalandırılmış',
    copyToNewOrderConfirmTitle: 'Yeni Siparişe Kopyalansın mı?',
    copyToNewOrderConfirmMessage: 'Bu, {id} siparişini iptal edecek, müşteriye tam iade yapacak ve yeniden fiyatlandırmanız için Yeni Siparişler bölümünde yeni bir kopya oluşturacaktır. Devam edilsin mi?',
    ordersPurchasedSuccessfully: 'Siparişler başarıyla satın alındı',
    orderPurchasedSuccessfully: 'Sipariş başarıyla satın alındı',
    sentSuccessfully: 'Başarıyla gönderildi',
    onceDeliveredPendingBranchWarning: 'Şubeye gönderilmeyi bekleyene teslim edildikten sonra bu siparişi bu adıma geri döndüremezsiniz!',
    confirmSendToBranchDelivery: 'Bu, seçilen siparişleri doğrudan Şube Teslimatına gönderecektir.',
    sortByOrder: 'Sipariş',
    sortByConfirm: 'Onay',
    sortByPurchase: 'Satın Alma',
    someOrdersNotMarkedDelivered: 'Bazı siparişler teslim edildi olarak işaretlenmedi',
    orderAlreadyInvoicedTitle: 'Bu sipariş zaten faturalandırılmış',
    confirmAttachToDeliveryRequest: 'Bu, seçilen siparişleri bu müşterinin teslimat talebine ekleyecektir — bekleyen bir talebi yoksa yeni bir tane oluşturulacaktır.',
    moveToDamageConfirmTitle: 'Hasarlıya Taşınsın mı?',
    confirmMoveToDamage: 'Bu siparişi hasarlı durumuna taşımak istediğinizden emin misiniz?',
    moveToReturnConfirmTitle: 'İadeye Taşınsın mı?',
    confirmMoveToReturn: 'Bu siparişi iade durumuna taşımak istediğinizden emin misiniz?',
    editThisOrderTooltip: 'Bu Siparişi Düzenle',
    addRefundNumberTooltip: 'İade numarası ekle',
    onceSentWarning: 'Gönderildikten sonra bu siparişi bu adıma geri döndüremezsiniz!',
    onceSentPluralWarning: 'Gönderildikten sonra bu siparişleri bu adıma geri döndüremezsiniz!',
    confirmGenerateQrSendIntShipment: 'Bu, seçilen siparişler için QR kodları oluşturacak ve doğrudan Uluslararası Sevkiyata gönderecektir.',
    confirmSendDirectlyToBranchDelivery: 'Bu, siparişi doğrudan Şube Teslimatına gönderecektir. Bu adıma geri döndüremezsiniz!',
    pendingShipmentTooltip: 'Sevkiyat Bekliyor',
    sendToIntShipmentTitle: 'Uluslararası Sevkiyata Gönder',
    returnToPurchaseTooltip: 'Satın Almaya Geri Döndür',
    takePhotoTooltip: 'Fotoğraf Çek',
    createCaseTooltip: 'Vaka Oluştur',
    pleaseAtLeastSelectOneOrder: 'Lütfen en az bir sipariş seçin!',
    currentPageScopeNote: 'mevcut sayfa',
    filtersToggleLabel: 'Filtreler',
    oncePendingShipmentedWarning: 'Sevkiyat bekliyor durumuna alındıktan sonra bu siparişi bu adıma geri döndüremezsiniz!',
    confirmReturnToPurchasedSection: 'Bu siparişi Satın Alındı bölümüne geri döndürmek istediğinizden emin misiniz?',
    damageOrdersTitle: 'Hasarlı Siparişler',
    returnOrdersTitle: 'İade Siparişleri',
    cancelOrderTooltip: 'Siparişi İptal Et',
    newExportOrdersTitle: 'Yeni İhracat Siparişleri',
    processedExportOrdersTitle: 'İşlenmiş İhracat Siparişleri',
    canceledExportOrdersTitle: 'İptal Edilmiş İhracat Siparişleri',
    approvedExportOrdersTitle: 'Onaylanmış İhracat Siparişleri',
    sentExportOrdersTitle: 'Gönderilmiş İhracat Siparişleri',
    receivedExportOrdersTitle: 'Teslim Alınmış İhracat Siparişleri',
    exportHistoryTitle: 'İhracat Geçmişi',
    refundedExportOrdersTitle: 'İade Edilmiş İhracat Siparişleri',
    processTooltip: 'İşle',
    cancelTooltip: 'İptal',
    approveTooltip: 'Onayla',
    sendTooltip: 'Gönder',
    receiveTooltip: 'Teslim Al',
    partialRefundTooltip: 'Kısmi İade',
    fullRefundTooltip: 'Tam İade',
    approvedStatusTitle: 'Onaylandı',
    sentStatusTitle: 'Gönderildi',
    receivedStatusTitle: 'Teslim Alındı',
    pendingToShipmentOrdersTitle: 'Sevkiyat Bekleyen Siparişler',
    shipmentThisOrderTooltip: 'Bu Siparişi Sevk Et',
    onceShipmentedWarning: 'Sevk edildikten sonra bu siparişi bu adıma geri döndüremezsiniz!',
    notFoundOrdersTitle: 'Bulunamayan Siparişler',
    trashTooltip: 'Sil',
    allowToSendTooltip: 'Göndermeye İzin Ver',
    convertToOrderTooltip: 'Siparişe Dönüştür',
    convertToOrderTitle: 'Siparişe Dönüştür',
    deliveredToErbilOption: 'Erbil\'e Teslim Edildi',
    addedTitle: 'Eklendi',
    orderCasesTitle: 'Sipariş Vakaları',
    sendToStaffTooltip: 'Personele Gönder',
    refundTooltip: 'İade',
    replaceTooltip: 'Değiştir',
    imagesTooltip: 'Resimler',
    orderCaseProgressTitle: 'Sipariş Vaka İlerlemesi',
    convertedToOrderStatus: 'Siparişe Dönüştürüldü',
    pendingStatus: 'Beklemede',
    processingStatus: 'İşleniyor',
    viewDetails: 'Detayları Görüntüle',
    cancelThisOrder: 'Bu Siparişi İptal Et',
    sendToPendingAnswerTooltip: 'Yanıt bekleniyor olarak gönder',
    sendToProcessTooltip: 'İşleme Gönder',
    orderSort: 'Sipariş Sıralaması',
    dateTypeLabel: 'Tarih Türü',
    newestFirst: 'Önce En Yeni',
    oldestFirst: 'Önce En Eski',
    homeDelivery: 'Eve Teslimat',
    officeDelivery: 'Ofise Teslimat',
    sendThisOrderToProcess: 'Bu sipariş işleme gönderilsin mi?',
    sendAllSelectedToProcess: 'Seçilen tüm siparişler işleme gönderilsin mi?',
    sendToPendingAnswerConfirm: 'Yanıt Bekleniyor Olarak Gönder',
    pleaseSelectOrder: 'Lütfen bir sipariş seçin',
    warehousesPlaceholder: 'Depolar',
    processThisOrderTooltip: 'Bu Siparişi İşle',
    theOrderIsProcessed: 'Sipariş İşlendi',
    editOrderInfoSection: 'Sipariş Bilgisini Düzenle',
    customerLockedHint: 'Kilitli — müşteriyi değiştirmek için Sipariş Müşterisini Yeniden Ata\'yı kullanın',
    requestName: 'Talep Adı',
    requestLink: 'Talep Bağlantısı',
    uploadOrderImage: 'Sipariş Görseli Yükle',
    requestDescription: 'Talep Açıklaması',
    editOrderPriceSection: 'Sipariş Fiyatını Düzenle',
    itemPriceLabel: 'Ürün Fiyatı ({unit})',
    discountedShippingPriceLabel: 'İndirimli kargo fiyatı ($)',
    discountLabel: 'İndirim ({unit})',
    deliveryIqdLabel: 'Teslimat (IQD)',
    estimateTimeToArrivalLabel: 'Tahmini Varış Süresi (gün)',
    customerProcessNoteLabel: 'Müşteri işlem notu',
    uploadImage: 'Görsel Yükle',
    otherServiceNoteLabel: 'Diğer hizmet notu',
    reason: 'Neden',
    bulkNewOrdersTitle: 'Toplu Yeni Siparişler',
    allItemsOrderedSuccessfully: 'Tüm ürünler başarıyla sipariş edildi!',
    customerRequiredError: 'Müşteri gereklidir',
    warehouseCountryLabel: 'Depo / Ülke',
    warehouseRequiredError: 'Depo gereklidir',
    itemNamePlaceholder: 'Ürün adı',
    addRowButton: 'Satır Ekle',
    countPlaceholder: 'Adet',
    numberOfRowsToAddHint: 'Eklenecek satır sayısı (0 veya boş = 1)',
    itemsTotalLabel: 'Toplam {count} ürün',
    sendToPurchaseLabel: 'Satın Almaya Gönder',
    submitAllOrdersButton: 'Tüm Siparişleri Gönder',
    removeRowTitle: 'Satırı Kaldır',
    pickColorTitle: 'Bir renk seçin',
    maxOrdersLimitError: 'Bir seferde en fazla {max} sipariş ekleyebilirsiniz.',
    onlyRowsAddedLimitError: 'Yalnızca {count} satır eklendi — {max} sipariş sınırına ulaşıldı.',
    unsupportedImageTypeError: '"{fileName}" dosyası desteklenen bir resim türü değil. İzin verilenler: {allowed}.',
    fileSizeLimitError: '"{fileName}" dosyası 50MB boyut sınırını aşıyor.',
    uploadingImagesProgress: 'Resimler yükleniyor {done}/{total}...',
    savingOrders: 'Siparişler kaydediliyor...',
    gifSizeLimitError: '"{fileName}" GIF dosyası 2MB sınırını aşıyor. Lütfen JPG veya PNG kullanın.',
    imagesStillProcessingError: 'Bazı resimler hâlâ hazırlanıyor. Lütfen biraz bekleyip tekrar gönderin.',
    uploadTooLargeError: 'Yükleme sunucu için çok büyük. Lütfen daha az veya daha küçük resim yükleyin.',
    rowItemNameRequiredError: 'Satır {row}: Ürün adı gereklidir.',
    rowLinkRequiredError: 'Satır {row}: Bağlantı (URL) gereklidir.',
    rowQuantityMinError: 'Satır {row}: Miktar en az 1 olmalıdır.',
    viewOrderDetailsTitle: 'Sipariş Detaylarını Görüntüle',
    itemPriceCurrencyLabel: 'Ürün Fiyatı {code}',
    refundAmountLabel: 'İade Tutarı',
    partialRefundsLabel: 'Kısmi İadeler',
    partialRefundAtBy: '{date} tarihinde {name} tarafından',
    newOrderTitle: 'Yeni sipariş',
    itemOrderedSuccessfully: 'Ürün başarıyla sipariş edildi',
    urlFormatNotAcceptable: 'URL biçimi kabul edilemez',
    intShippingUsdLabel: 'Uluslararası Kargo ($)',
    imageUrlOptionalLabel: 'Resim URL (isteğe bağlı)',
    urlWillBeUsedInsteadHint: 'Dosya yükleme yerine URL kullanılacak',
    purchaseBankLabel: 'Satın Alma Bankası',
    otherServiceSpecifyLabel: 'Diğer hizmet (lütfen belirtin)',
    couponCodeRequiredError: 'Bu alan bir Kupon Kodu içermelidir',
    fileSizeExceedsError: '{field} {size} MB\'ı aşmamalıdır.',
    unsupportedImageTypeShort: 'Desteklenmeyen resim türü. İzin verilenler: {allowed}.',
    fileSizeLimitShort: 'Dosya 50MB boyut sınırını aşıyor.',
    uploadPhotoButton: 'Fotoğraf Yükle',
    partialRefundInvoiceTitle: 'Kısmi İade Faturası',
    newStatus: 'yeni',
    updateShipOnlyTitle: 'Sadece kargoyu güncelle',
    newShipOnlyTitle: 'Yeni sadece kargo',
    orderedSuccessfully: 'Başarıyla sipariş edildi',
    fromDateGreaterThanTodayError: 'Başlangıç tarihi bugünden büyük olmalıdır',
    toDateGreaterThanFromDateError: 'Bitiş tarihi başlangıç tarihinden büyük olmalıdır'
  },
  delivery: {
    orderDeliveryTitle: 'Sipariş Teslimatı',
    changeStatusTooltip: 'Durumu Değiştir',
    viewInvoiceTooltip: 'Faturayı Görüntüle',
    viewCustomerOrdersImagesTooltip: 'Müşteri Siparişlerini ve Resimlerini Görüntüle',
    editDeliveryPriceTooltip: 'Teslimat Ücretini Düzenle',
    deliveryRequestDeleteConfirm: 'Bu teslimat talebi kalıcı olarak silinecektir.',
    deletedTitle: 'Silindi',
    deliveryPriceIqdTitle: 'Teslimat Ücreti (IQD)',
    deliveryPricePlaceholder: 'Teslimat ücreti',
    pleaseSelectAtLeastOneDeliveryRequest: 'Lütfen en az bir teslimat talebi seçin!',
    postStatus: 'Gönderiye Ver',
    holdStatus: 'Beklet',
    completeStatus: 'Tamamlandı',
    orderDeliveryInvoiceTitle: 'Sipariş Teslimat Faturası',
    invoicedToLabel: 'Faturalanan',
    phone2Label: 'Telefon 2',
    detachTooltip: 'Bu teslimat talebinden ayır',
    orderNumberColumn: 'Sipariş No',
    totalOrdersLabel: 'Toplam Sipariş:',
    totalUsdLabel: 'Toplam USD:',
    iraqiDinarLabel: 'IRAK DİNARI:',
    totalIqdColonLabel: 'Toplam IQD:',
    attachedOrdersNotYetInvoiced: 'Eklenen Siparişler (henüz faturalanmadı)',
    orderColumn: 'Sipariş',
    productColumn: 'Ürün',
    detachConfirmTitle: 'Bu fatura ayrılsın mı?',
    detachConfirmText: '{invoice} artık bu teslimat talebinin parçası olmayacak. Normal bir kargo faturası olarak kalır ve daha sonra tekrar eklenebilir.',
    deliveryInvoiceTitle: 'Teslimat Faturası',
    customerBalanceLabel: 'Müşteri Bakiyesi:',
    deliveryMethodLabel: 'Teslimat Yöntemi:',
    pickupInOfficeLabel: 'Teslim Alma (Ofisten)',
    payOnDeliveryLabel: 'Teslimatta Ödeme:',
    deliveryInvoicesTitle: 'Teslimat Faturaları',
    invoiceSelectedCount: '{count} fatura seçildi',
    selectStatusLabel: 'Durum Seç',
    totalRecordsFooter: 'Toplam Kayıt: {count}',
    totalPriceFooter: 'Toplam Fiyat: {amount}',
    totalDeliveryPriceFooter: 'Toplam Teslimat Fiyatı: {amount} IQD',
    deliveryPriceFooter: 'Teslimat Fiyatı: {amount} IQD',
    viewShippingInvoicesTooltip: '{count} Kargo Faturasını Görüntüle',
    thisDeliveryInvoiceWillBeDeleted: 'Bu teslimat faturası kalıcı olarak silinecek.',
    pleaseSelectAtLeastOneDeliveryInvoice: 'Lütfen en az bir teslimat faturası seçin!',
    markAllSelectedInvoicesAsReceivedConfirm: 'Bu, seçili tüm teslimat faturalarını alındı olarak işaretleyecektir.',
    unmarkAllSelectedInvoicesAsReceivedConfirm: 'Bu, seçili tüm teslimat faturalarının alındı işaretini kaldıracaktır (alınan tutarlar ve tarih temizlenecektir).',
    partialReceivedStatus: 'Kısmi Alındı',
    payOnDeliveryIqdLabel: 'Teslimatta ödeme (IQD)',
    pickupLabel: 'Teslim Alma',
    notConfirmedLabel: 'Onaylanmadı',
    requestDeliveryTitle: 'Teslimat Talebi',
    customerRequiredLabel: 'Müşteri*',
    noteOptionalLabel: 'Not (isteğe bağlı)',
    changeStatusTitle: 'Durumu Değiştir',
    requestsSelectedSuffix: 'talep seçildi',
    invoiceColonPrefix: 'Fatura:',
    custNoteColumn: 'Müş. Notu',
    createdColumn: 'Oluşturulma'
  },
  invoice: {
    shippingInvoiceTitle: 'Gönderim Faturası',
    receivedInvoicesTitle: 'Alınan Faturalar',
    invoiceTooltip: 'Fatura',
    recordPaymentTooltip: 'Ödeme Kaydet',
    logsTooltip: 'Kayıtlar',
    failedToDeleteInvoice: 'Fatura silinemedi — kaldırılmadı.',
    somethingWentWrong: 'Bir şeyler ters gitti!',
    pleaseSelectAtLeastOneInvoice: 'Lütfen en az bir fatura seçin!',
    ordersInvoiceTitle: 'Sipariş Faturası',
    creditInvoiceTitle: 'Bakiye Faturası',
    confirmMarkAllPaid: 'Bu, seçilen tüm faturaları tamamen ödenmiş olarak işaretleyecektir.',
    confirmMarkAllReceived: 'Bu, seçilen tüm faturaları teslim alındı olarak işaretleyecektir.',
    confirmUnmarkAllReceived: 'Bu, seçilen tüm faturaların teslim alındı işaretini kaldıracaktır (sahip, teslim alma tarihi ve alınan tutar temizlenecektir).',
    cashReceivedInDaysLabel: 'Bu günlerde alınan nakit:',
    cashReceivedInDaysHint: 'Yalnızca seçilen teslim alma tarihlerinde teslim edilen yeni para. Toplam Alınan’dan farklı olarak, fatura daha sonra tekrar teslim alındığında değişmez.',
    confirmToggleOutOffice: 'Bu, seçilen faturaların ofis dışı durumunu değiştirecektir.',
    pleaseSelectAtLeastTwoPaidInvoices: 'Lütfen birleştirmek için en az iki ödenmiş fatura seçin!',
    paidStatus: 'Ödendi',
    partialPaidStatus: 'Kısmi Ödendi',
    unpaidStatus: 'Ödenmedi',
    receivedAtOption: 'Teslim Alma Tarihi',
    singleOption: 'Tekli',
    batchOption: 'Toplu',
    digitalOption: 'Dijital',
    officeOption: 'Ofis',
    manualOption: 'Manuel',
    refundExistsOption: 'İade Var',
    noRefundOption: 'İade Yok',
    generateInvoiceTitle: 'Fatura Oluştur',
    customerLabel: 'Müşteri: {name}',
    phoneNumberLabel: 'Telefon numarası: {phone}',
    ordersLabel: 'Siparişler',
    shipmentLabel: 'Sevkiyat',
    handlingFeeLabel: 'İşlem Ücreti',
    totalPriceLabel: 'Toplam fiyat',
    totalIqdLabel: 'Toplam IQD',
    paidAmountLabel: 'Ödenen tutar',
    remainingAfterSelectedOrders: 'Seçili siparişlerin mevcut faturalarından sonra kalan: {usd} / {iqd} IQD',
    remainingFromOtherPartialInvoices: 'Diğer kısmi ödenmiş faturalardan kalan: {usd} / {iqd} IQD',
    loadingText: 'Yükleniyor...',
    balanceLabel: 'Bakiye',
    remainingBalanceLabel: 'Kalan Bakiye',
    shippingInvoiceNoLabel: 'Nakliye fatura no:',
    customerOutOfficeTotalNote: 'Bu müşteri için toplam Ofis Dışı: {amount}',
    cashAndView: 'Nakit ve görüntüle',
    outOfficeButton: 'Ofis Dışı',
    viewButton: 'Görüntüle',
    deliveryButton: 'Teslimat',
    cancelStatus: 'İptal',
    notPaidWatermark: 'ÖDENMEDİ',
    invoiceNoteLabel: 'Fatura Notu:',
    secondaryInvoiceGeneratedNote: 'Bu sipariş için ikincil fatura oluşturuldu',
    invoiceSavedNoPreview: 'Fatura kaydedildi ancak önizleme açılamadı (fatura kimliği eksik).',
    invoiceGeneratedSuccessfully: 'Fatura başarıyla oluşturuldu',
    requestFailed: 'İstek başarısız oldu',
    invoiceSavedNoAttach: 'Fatura kaydedildi ancak teslimata eklenemedi (fatura kimliği eksik).',
    attachFailed: 'Ekleme başarısız oldu',
    invoiceCreatedCouldNotAttach: 'Fatura oluşturuldu, ancak eklenemedi: {msg}',
    alreadyAttachedNote: '{list} zaten bir teslimat talebine eklenmiş — tekrar eklenmedi.'
  },
  navbar: {
    creditLabel: 'Bakiye:',
    addBalance: 'Bakiye Ekle',
    subscription: 'Abonelik',
    exchangeRateLabel: 'Döviz Kuru:',
    capital: 'Sermaye',
    verifyAccountButton: 'Hesabınızı doğrulayın',
    printLogs: 'Yazdırma Kayıtları',
    warehouseDatePassedOrders: 'Depo tarihi geçen siparişler',
    warehouseDateLabel: 'Depo Tarihi:',
    notifications: 'Bildirimler'
  },
  sidebar: {
    toggleAllNavigations: 'Tüm Menüleri Aç/Kapat',
    dashboard: 'Kontrol Paneli',
    statisticsDashboard: 'İstatistik Panosu',
    loanedCustomerTitle: 'Borçlu müşteri',
    customerPricesTitle: 'Müşteri fiyatları',
    orderCasesProgressTitle: 'Sipariş Vakası İlerlemesi',
    orderTypesTitle: 'Sipariş Türleri',
    chargeBalanceTitle: 'Bakiye Yükle',
    shipOnlyNewTitle: 'Sadece Sevkiyat (Yeni)',
    orderInvoicesTitle: 'Sipariş Faturaları',
    shippingInvoicesTitle: 'Gönderim Faturaları',
    creditInvoicesTitle: 'Kredi Faturaları',
    partialRefundInvoicesTitle: 'Kısmi İade Faturaları',
    orders: 'Siparişler',
    tools: 'Araçlar',
    export: 'Dışa Aktar',
    import: 'İçe Aktar',
    delivery: 'Teslimat',
    invoices: 'Faturalar',
    finance: 'Finans',
    cases: 'Vakalar',
    customers: 'Müşteriler',
    reports: 'Raporlar',
    mobileApp: 'Mobil Uygulama',
    admin: 'Yönetim'
  },
  warehouse: {
    warehousesTitle: 'Depolar',
    updateWarehouseTitle: 'Depoyu Güncelle',
    warehouseUpdatedSuccessfully: 'Depo başarıyla güncellendi',
    estimateDaysLabel: 'Tahmini gün (teslimat penceresi)',
    houseNumberLabel: 'Ev Numarası',
    stateProvinceLabel: 'Eyalet - İl',
    prefixLabel: 'Önek',
    flagCodeHint: 'Bayrak Kodu (ISO 2 harf, örn. tr, us, ae, cn, gb, de)',
    customCodeLabel: 'Özel Kod',
    transportationTypesLabel: 'Taşımacılık Türleri',
    defaultImageLabel: 'Varsayılan Görsel'
  },
  user: {
    staffTitle: 'Personel',
    totalIncomeAddLabel: 'Toplam gelir (Ekle +)',
    totalOutgoingCashBackLabel: 'Toplam çıkış (Nakit İade -)',
    verifiedAtLabel: 'Şu tarihte doğrulandı:',
    customersTitle: 'Müşteriler',
    editCustomerTooltip: 'Müşteriyi Düzenle',
    customerTransactionTooltip: 'Müşteri işlemi',
    customerTransactionsTitle: '{name} İşlemleri',
    removeFilterButton: 'Filtreyi Kaldır',
    openingBalanceLabel: 'Açılış Bakiyesi',
    updateCustomerTitle: 'Müşteriyi Güncelle',
    codEnabledLabel: 'Kapıda Ödeme',
    codEnabledHint: 'Bu müşterinin cüzdan bakiyesi olmadan siparişleri onaylamasına izin ver',
    block: 'Engelle',
    unblock: 'Engeli Kaldır',
    editStaffTooltip: 'Personeli Düzenle',
    resetPasswordTooltip: 'Şifreyi Sıfırla',
    resetPasswordSuccessfully: 'Şifre başarıyla sıfırlandı',
    blockThisUserTooltip: 'Bu Kullanıcıyı Engelle',
    unblockThisUserTooltip: 'Bu Kullanıcının Engelini Kaldır',
    notAllowed: 'İzin Verilmiyor',
    cannotResetOwnPassword: 'Şifrenizi buradan sıfırlayamazsınız, yalnızca başkalarının şifresini sıfırlayabilirsiniz',
    personalInformation: 'Kişisel Bilgiler',
    updateCoverImageButton: 'Kapak Resmini Güncelle',
    fullName: 'Ad Soyad',
    addCustomerTitle: 'Müşteri Ekle',
    customerFullNameLabel: 'Müşteri Adı Soyadı',
    fullNameTwoWordsError: 'Ad soyad, boşlukla ayrılmış en az iki kelime içermelidir',
    addStaffTitle: 'Personel Ekle',
    staffAddedSuccessfully: 'Personel başarıyla eklendi',
    passwordDoNotMatch: 'Şifre eşleşmiyor',
    phoneMustStartWith964Error: 'Telefon numarası +964 ile başlamalıdır',
    updateStaffTitle: 'Personeli Güncelle',
    staffUpdatedSuccessfully: 'Personel başarıyla güncellendi',
    changePasswordTitle: 'Şifreyi Değiştir',
    currentPassword: 'Mevcut şifre',
    newPassword: 'Yeni şifre',
    confirmPassword: 'Şifreyi onayla',
    changeSecretKeyTitle: 'Gizli Anahtarı Değiştir',
    currentSecret: 'Mevcut gizli anahtar',
    newSecret: 'Yeni gizli anahtar',
    confirmSecret: 'Gizli anahtarı onayla',
    createSecretKeyTitle: 'Gizli Anahtar Oluştur',
    secretKey: 'Gizli anahtar',
    companyInfoTitle: 'Şirket bilgisi',
    companyName: 'Şirket adı',
    companyEmail: 'Şirket e-postası',
    companyAddress: 'Şirket adresi',
    confirmPasswordNotMatch: 'Şifre onayı eşleşmiyor',
    passwordChangedSuccessfully: 'Şifre Başarıyla Değiştirildi',
    currentPasswordIncorrect: 'Mevcut Şifre yanlış',
    profileMustBeImage: 'Profil bir resim olmalıdır',
    coverMustBeImage: 'Kapak bir resim olmalıdır',
    secretKeyIncorrect: 'Mevcut gizli anahtar yanlış',
    secretKeyChangedSuccessfully: 'Gizli anahtar başarıyla değiştirildi',
    currentSecretKeyRequired: 'Mevcut gizli anahtar gereklidir',
    newSecretKeyRequired: 'Yeni gizli anahtar gereklidir',
    confirmSecretKeyRequired: 'Gizli anahtar onayı gereklidir',
    confirmSecretNotMatch: 'Gizli anahtar onayı eşleşmiyor',
    secretKeyCreatedSuccessfully: 'Gizli anahtar başarıyla oluşturuldu',
    alreadyHaveSecretKey: 'Zaten bir gizli anahtarınız var',
    secretKeyRequired: 'Gizli anahtar gereklidir',
    companyInfoUpdatedSuccessfully: 'Şirket bilgisi başarıyla güncellendi',
    customerSubscriptionsTitle: 'Müşteri Abonelikleri',
    editSubscriptionTooltip: 'Aboneliği Düzenle',
    deleteCustomerSubscriptionTooltip: 'Müşteri Aboneliğini Sil',
    pleaseSelectAtLeastOneSubscriptionToDelete: 'Lütfen silmek için en az bir müşteri aboneliği seçin',
    deleteCustomerSubscriptionConfirm: 'Müşteri aboneliği silinsin mi: {name}?',
    deleteAllCustomerSubscriptionsConfirm: 'Seçilen tüm müşteri abonelikleri silinsin mi?',
    customerCreditTitle: 'Müşteri Bakiyesi',
    onceDeletedCreditWarning: 'Silindikten sonra bu bakiyeyi geri getiremezsiniz!',
    onceDeletedCashBackWarning: 'Silindikten sonra bu para iadesini geri getiremezsiniz!',
    customerDefaultPricesTitle: 'Müşteri varsayılan fiyatları'
  },
  reports: {
    salesReportTitle: 'Satış Raporu',
    gainedReportTitle: 'Kazanç Raporu',
    expensesReportTitle: 'Gider Raporu',
    invoicesReportTitle: 'Fatura Raporu',
    orderCostsReportTitle: 'Sipariş Maliyet Raporu',
    buysReportTitle: 'Satın Alma Raporu',
    customersReportTitle: 'Müşteri Raporu',
    customerInvoicesReportTitle: 'Müşteri Fatura Raporu',
    deliveryReportTitle: 'Teslimat Raporu',
    dailyRevenueReportTitle: 'Günlük Gelir Raporu',
    deliveredReportTitle: 'Teslim Edilen Raporu',
    profitReportTitle: 'Kâr Raporu',
    unpaidArrivedInvoicesTitle: 'Ödenmemiş Gelen Faturalar',
    unpaidReceivedInvoicesTitle: 'Ödenmemiş Teslim Alınan Faturalar',
    ordersReportTitle: 'Sipariş Raporu',
    revenueReportTitle: 'Gelir Raporu',
    orderStatusReportTitle: 'Sipariş Durumu Raporu',
    numberOfOrders: 'Sipariş Sayısı',
    numberOfRequests: 'Talep Sayısı',
    totalRequests: 'Toplam Talep',
    totalBuy: 'Toplam Satın Alma',
    totalExpenses: 'Toplam Gider',
    totalSales: 'Toplam Satış',
    totalGained: 'Toplam Kazanç',
    staffMember: 'Personel',
    paymentStatus: 'Ödeme Durumu',
    count: 'Sayı',
    paid: 'Ödenen',
    transportation: 'Taşıma',
    totalCost: 'Toplam Maliyet',
    net: 'Net',
    totalRevenue: 'Toplam Gelir',
    orderCount: 'Sipariş Sayısı',
    request: 'Talep',
    exchangeDifference: 'Kur Farkı',
    shippingCost: 'Gönderim Maliyeti',
    deliveryIqd: 'Teslimat (IQD)',
    totalGain: 'Toplam Kazanç',
    apply: 'Uygula',
    printReport: 'Raporu Yazdır',
    pleaseSelectFromToDate: 'Lütfen Başlangıç ve Bitiş Tarihi seçin',
    failedToLoadReport: 'Rapor yüklenemedi',
    pleaseSelectStatusFromToDate: 'Lütfen bir durum, Başlangıç ve Bitiş Tarihi seçin',
    failedToLoadInvoices: 'Faturalar yüklenemedi',
    customerWhoPlacedOrders: 'Siparişi/siparişleri veren müşteri',
    orderCountSubLabelSuffix: '= bu müşteri tarafından dönem içinde verilen, seçili durumdaki siparişler',
    periodColon: 'Dönem:',
    acrossAllCustomers: 'tüm müşteriler genelinde',
    notPaidHeader: 'Ödenmemiş',
    notPaidSubLabel: 'Ödenen tutarı 0 olan faturalar',
    partialPaidHeader: 'Kısmi Ödenmiş',
    partialPaidSubLabel: 'Ödenen tutarı 0 ile toplam arasında olan faturalar',
    paidSubLabel: 'Ödenen tutarı toplama eşit veya fazla olan faturalar',
    equalsInvoiceCount: '= fatura sayısı',
    equalsSigmaInvoiceAmount: '= Σ fatura tutarı',
    equalsSigmaAmountPaid: '= Σ ödenen tutar',
    allCustomersOption: 'Tüm Müşteriler',
    telColonPrefix: 'Tel: ',
    totalShippingCardTitle: 'Toplam Kargo',
    equalsSigmaShippingCost: '= dönem içinde teslim edilen siparişlerin Σ kargo maliyeti',
    totalShipzoneFeeCardTitle: 'Toplam Shipzone Ücreti',
    equalsSigmaShipzoneServiceFee: '= dönem içinde teslim edilen siparişlerin Σ ShipZone hizmet ücreti',
    totalOrders: 'Toplam Sipariş',
    grandTotal: 'Genel Toplam',
    orderStatusStageHint: 'Sipariş durumu/aşaması',
    equalsCountOrdersWithStatus: '= bu durumdaki sipariş sayısı',
    equalsSigmaOrderAmount: '= Σ sipariş tutarı',
    qtyShipTotalPerCountryHint: 'Adet = N; Kargo = Σ kargo (S); Toplam = Σ tutar (A) bu ülke için',
    requestsGroupedByCountryHint: 'Talepler hedef ülkeye göre gruplandı',
    ordersGroupedByCountryHint: 'Siparişler hedef ülkeye göre gruplandı',
    equalsCountBuyRequestsInCountry: '= bu ülkedeki satın alma talebi sayısı',
    equalsSigmaOrderAmountPreDiscount: '= Σ sipariş tutarı (indirim öncesi)',
    equalsSigmaDiscountApplied: '= Σ uygulanan indirim',
    groupedByTransportationMethodHint: 'Taşıma yöntemine göre gruplandı',
    equalsCountOrdersUsingTransportation: '= bu taşıma yöntemini kullanan sipariş sayısı',
    equalsSigmaOrderCostPreDiscount: '= Σ sipariş maliyeti (indirim öncesi)',
    equalsSigmaRevenueCollected: '= Σ bu taşıma yöntemi için tahsil edilen gelir',
    sigmaDeliveriesSigmaIqdHint: 'Σ teslimat, Σ IQD',
    equalsCountOrdersInCountry: '= bu ülkedeki sipariş sayısı',
    equalsSigmaOrderAmountForCountry: '= Σ bu ülke için sipariş tutarı',
    employeeWhoRecordedExpenseHint: 'Gideri kaydeden çalışan',
    equalsSigmaExpenseAmountByStaff: '= Σ bu çalışan tarafından kaydedilen gider tutarı',
    sigmaAAcrossAllStaffHint: 'Tüm personel için ΣA',
    accountStatusActiveInactiveHint: 'Hesap durumu: Aktif / Pasif',
    equalsCustomersWithStatusInPeriod: '= bu durumdaki, dönem içinde kayıt olan müşteriler',
    totalRegistered: 'Toplam Kayıtlı',
    invoiceStatusHint: 'Fatura durumu: Ödenmedi / Kısmi / Ödendi',
    equalsInvoicesWithStatus: '= bu durumdaki faturalar',
    totalShipmentCardTitle: 'Toplam Sevkiyat',
    totalTaxCardTitle: 'Toplam Vergi',
    invoiceShipmentCardTitle: 'Fatura Sevkiyatı',
    netIncomeCardTitle: 'Net Gelir',
    equalsSigmaShipmentCost: '= Σ sevkiyat maliyeti',
    equalsSigmaShipzoneFeeCard: '= Σ ShipZone ücreti',
    equalsSigmaTaxCollected: '= Σ tahsil edilen vergi',
    equalsSigmaShipmentAmountInvoiced: '= Σ müşterilere faturalanan sevkiyat tutarı',
    equalsSigmaRefundedAmountCard: '= Σ iade edilen tutar',
    equalsSigmaBusinessExpenses: '= Σ işletme giderleri',
    equalsRevenueAfterRefundsFeesBeforeExpenses: '= iadeler/ücretler sonrası, giderler öncesi gelir',
    orderDateHint: 'Sipariş tarihi',
    orderRequestIdHint: 'Sipariş / talep no',
    equalsItemPriceLocalCurrency: '= yerel para biriminde ürün fiyatı',
    currencyOfPHint: 'P para birimi (kırmızı = $, mavi = diğer)',
    equalsUnitsOnOrder: '= bu siparişteki birim sayısı',
    equalsBuyCostUsd: '= USD cinsinden alış maliyeti',
    equalsPerUnitExchangeMargin: '= birim başına kur marjı; Q > 1 olduğunda × Q',
    equalsPerUnitShippingCost: '= birim başına kargo maliyeti; Q > 1 olduğunda × Q',
    equalsDeliveryFeeIqd: '= IQD cinsinden teslimat ücreti',
    equalsRowGainApprox: '= bu satırın kazancı yaklaşık (B + C) × Q',
    totalRevenueAcrossRowsHint: 'Tüm satırlarda ΣB·Q, ΣC·Q, ΣD, ΣE',
    totalRevenueFooterLabel: 'TOPLAM GELİR:',
    businessExpensesFooterLabel: 'İşletme Giderleri:',
    equalsSigmaBusinessExpensesInPeriod: '= Σ dönem içindeki işletme giderleri',
    netGainAfterExpensesFooterLabel: 'NET KAZANÇ (giderler sonrası):',
    equalsCountOrdersInPeriod: '= dönem içindeki sipariş sayısı',
    equalsSigmaPurchaseBuyCost: '= Σ satın alma maliyeti',
    equalsSigmaSalesRevenue: '= Σ satış geliri'
  },
  mobileApp: {
    aboutAppSectionTitle: 'Uygulama Hakkında Bölümü',
    helpCenterSectionTitle: 'Yardım Merkezi (SSS) Bölümü',
    homeSliderTitle: 'Ana Sayfa Kaydırıcısı (Uygulama)',
    addNewHomeSliderButton: 'Yeni Ana Sayfa Kaydırıcısı Ekle',
    homeBannerTitle: 'Mobil Ana Sayfa Banner (Uygulama)',
    popularWebsiteTitle: 'Popüler Web Sitesi (Uygulama)',
    updatePopularWebsiteTitle: 'Popüler Web Sitesini Güncelle',
    addNewPopularWebsiteTitle: 'Yeni Popüler Web Sitesi Ekle',
    globalWebsiteGroupTitle: 'Küresel Web Sitesi Grubu (Uygulama)',
    websitesAppTitle: 'Web Siteleri (Uygulama)',
    addNewGlobalWebsiteButton: 'Yeni Küresel Web Sitesi Ekle',
    updateGlobalWebsiteTitle: 'Küresel Web Sitesini Güncelle',
    uploadLogo: 'Logo yükle',
    forceUpdateTitle: 'Zorunlu Güncelleme',
    linksTitle: 'Bağlantılar',
    ourAddressTitle: 'Adresimiz',
    updateOurAddressTitle: 'Adresimizi Güncelle',
    addNewOurAddressTitle: 'Yeni Adresimizi Ekle',
    customerAlreadyInList: 'Müşteri zaten listede',
    pleaseSelectCustomer: 'Lütfen müşteri seçin',
    pleaseEnterTitle: 'Lütfen başlık girin',
    pleaseEnterBody: 'Lütfen içerik girin'
  },
  admin: {
    couponsTitle: 'Kuponlar',
    editPercentageTooltip: 'Yüzdeyi Düzenle',
    giveToCustomerTooltip: 'Müşteriye Ver',
    onceDeletedCouponWarning: 'Silindikten sonra bu kuponu geri getiremezsiniz!',
    orderLogTitle: 'Sipariş Kaydı',
    viewStaffTooltip: 'Personeli Görüntüle',
    viewOrderTooltip: 'Siparişi Görüntüle',
    viewCustomerTooltip: 'Müşteriyi Görüntüle',
    activityLogTitle: 'Etkinlik Kaydı',
    shipZoneFeePricesTitle: 'ShipZone ücret fiyatları',
    suppliersTitle: 'Tedarikçiler',
    rolesTitle: 'Roller',
    assignPermissionTooltip: 'İzin Ata',
    settingsTitle: 'Ayarlar',
    securitySection: 'Güvenlik',
    profileSection: 'Profil',
    onlinePaymentSection: 'Online Ödeme',
    staleOrdersSection: 'Bekleyen Siparişler',
    requireSecretKeyLabel: 'Hassas sayfalar için gizli anahtar iste',
    lockFullNameEditLabel: 'Tam ad düzenlemesini kilitle (mobil) — bir müşterinin ad/soyadı belirlendikten sonra mobil uygulamadan bir daha değiştirilemez',
    allowChangingCanceledStatusLabel: 'İptal edilmiş siparişlerin durumunun değiştirilmesine izin ver (kapatıldığında iptal edilmiş siparişler başka durum değişikliğine kilitlenir)',
    autoCreateShippingInvoicesLabel: 'Bakiye yüklemesinde gönderilen siparişler için otomatik gönderim faturası oluştur (siparişler onay anında her zaman fatura alır ve bakiye yüklemesi her zaman mevcut bir faturayı kapatır; bu ayar yalnızca yeni bir FIB/QI/ofis bakiye yüklemesinin, henüz faturası olmayan gönderilmiş siparişler için proaktif olarak fatura oluşturup birleştirmesini mi yoksa personelin bunu Fatura Oluştur ile manuel yapmasını mı bekleyeceğini kontrol eder)',
    enableOnlinePaymentLabel: 'Bakiye ekleme ve sipariş ödemesi için online ödemeyi etkinleştir (FIB, QiCard, FastPay, ZainCash) — kapatıldığında uygulama genelinde tüm online ödeme yöntemleri engellenir. Kapıda Ödeme bu ayardan hiçbir zaman etkilenmez.',
    fibCommissionRateLabel: 'FIB komisyon oranı (%)',
    qiCommissionRateLabel: 'QI Kart komisyon oranı (%)',
    autoCancelStaleOrdersLabel: 'Yeni Sipariş veya İşlenmiş Sipariş durumunda takılı kalan siparişleri otomatik iptal et',
    hoursBeforeAutoCancelLabel: 'Otomatik iptalden önceki saat sayısı',
    notifyProcessedOrdersLabel: 'Onaylarını bekleyen İşlenmiş Siparişler hakkında müşterileri bilgilendir (toplu olarak gönderilir)',
    hoursBeforeReminderLabel: 'Hatırlatma bildiriminden önceki saat sayısı',
    securitySectionDesc: 'Hassas yönetici sayfalarına erişimi kontrol eder.',
    profileSectionDesc: 'Müşterilerin mobil uygulamadan profillerini nasıl düzenleyebileceğini kontrol eder.',
    ordersSectionDesc: 'Siparişler için durum değişikliği kuralları ve fatura oluşturma.',
    onlinePaymentSectionDesc: 'FIB/QiCard/FastPay/ZainCash kullanılabilirliği ve müşterinin FIB veya QI Card ile bakiye eklerken tutarına eklenen komisyon. Sipariş ödemelerinden asla komisyon alınmaz.',
    staleOrdersSectionDesc: 'Yeni Sipariş veya İşlenmiş Siparişte bekleyen siparişlerin otomatik iptali ve müşterinin henüz onaylamadığı İşlenmiş Siparişler için hatırlatma bildirimleri.',
    fibCommissionRateHint: 'Müşteri FIB ile bakiye eklediğinde tutara eklenir. Sipariş ödemelerini etkilemez.',
    qiCommissionRateHint: 'Müşteri QI Card ile bakiye eklediğinde tutara eklenir. Sipariş ödemelerini etkilemez.',
    hoursBeforeAutoCancelHint: 'Bir siparişin otomatik iptal edilmeden önce Yeni Sipariş veya İşlenmiş Sipariş durumunda ne kadar süre bekleyebileceği.',
    hoursBeforeReminderHint: 'İşlenmiş bir Siparişin, hatırlatma bildirimi gönderilmeden önce müşteri onayını ne kadar bekleyebileceği.',
    settingsUpdatedSuccessfully: 'Ayarlar başarıyla güncellendi',
    pleaseUpdateAnything: 'Lütfen bir şey güncelleyin',
    citiesTitle: 'Şehirler',
    governoratesTitle: 'İller',
    cancellationRefundReasonsTitle: 'İptal ve İade Nedenleri',
    deleteSubscriptionTooltip: 'Aboneliği Sil',
    subscriptionPricingTitle: 'Abonelik Fiyatlandırması',
    pleaseSelectAtLeastOneUserSubscriptionToDelete: 'Lütfen silmek için en az bir kullanıcı aboneliği seçin',
    editOrderTypeTooltip: 'Sipariş Türünü Düzenle',
    deleteOrderTypeTooltip: 'Sipariş Türünü Sil',
    deleteOrderTypeConfirm: 'Sipariş Türü Silinsin mi: {name}?',
    savedTitle: 'Kaydedildi'
  },
  customer: {
    myOrdersTitle: 'Siparişlerim',
    orderDetailTooltip: 'Sipariş Detayı',
    editOrderTooltip: 'Siparişi Düzenle',
    addTrackNumberTooltip: 'Takip numarası ekle',
    archiveThisOrderTooltip: 'Bu Siparişi Arşivle',
    onceArchivedWarning: 'Arşivlendikten sonra bu siparişi bu adıma geri döndüremezsiniz!',
    archivedTitle: 'Arşivlendi',
    orderCanceledLabel: 'Sipariş İptal Edildi:',
    refundReason: 'İade nedeni',
    processNote: 'İşlem Notu',
    processNoteImage: 'İşlem Notu Resmi',
    trackNo: 'Takip No',
    link: 'Bağlantı',
    couponPercentage: 'Kupon yüzdesi',
    color: 'Renk',
    deliveryType: 'Teslimat türü',
    deliveryTypeUpdatedSuccessfully: 'Teslimat türü başarıyla güncellendi',
    repackage: 'Yeniden Paketleme',
    hold: 'Bekletme',
    otherService: 'Diğer Hizmet',
    quantityCharge: 'Miktar ücreti',
    itemPrice: 'Ürün fiyatı',
    internationalTax: 'Uluslararası Vergi',
    itemType: 'Ürün türü',
    addItemTypeTitle: 'Ürün Türü Ekle',
    itemAddedSuccessfully: 'Ürün başarıyla eklendi',
    shippingPrice: 'Gönderim Ücreti',
    discountedShippingPrice: 'İndirimli Gönderim Ücreti',
    insurance: 'Sigorta',
    repackagePrice: 'Yeniden Paketleme Ücreti',
    holdPrice: 'Bekletme Ücreti',
    otherServicePrice: 'Diğer Hizmet Ücreti',
    handlingFee: 'İşlem Ücreti',
    itemWeightLb: 'Ürün ağırlığı (LB)',
    archivedOrdersTitle: 'Arşivlenmiş Siparişler',
    orderDate: 'Sipariş Tarihi',
    otherServiceSpecify: 'Diğer hizmet (lütfen belirtin)',
    couponCodeValidation: 'Bu alan bir Kupon Kodu içermelidir',
    amountInIqdIs: 'IQD cinsinden tutar:',
    scanThisQrCode: 'Bu QR Kodu Tarayın',
    payWithLabel: 'Şununla öde',
    minimumAmountHint: 'Minimum tutar ($0.2) veya (250 IQD)',
    nextButton: 'İleri',
    enterCodeManuallyHint: 'veya bu kodu manuel olarak girin',
    tryAgainButton: 'Tekrar Dene',
    chargeYourAccount: 'Hesabınıza bakiye yükleyin',
    selectPaymentMethod: 'Ödeme yöntemi seçin',
    qiPaymentChecking: 'QI ödemeniz kontrol ediliyor…',
    qiPaymentSuccess: 'Ödeme alındı — bakiyeniz güncellendi.',
    qiPaymentPending: 'QI ödemeniz hâlâ işleniyor. Onaylandığında bakiyeniz otomatik olarak güncellenecek.',
    qiPaymentCancelled: 'QI ödemesi iptal edildi. Herhangi bir ücret alınmadı.',
    qiPaymentFailed: 'QI ödemesi başarısız oldu. Lütfen tekrar deneyin veya başka bir ödeme yöntemi seçin.',
    cancelOrderTitle: 'Siparişi İptal Et',
    cancelReasonLabel: 'İptal nedeni',
    deliverBranchLabel: 'Teslimat Şubesi',
    approvedTitle: 'Onaylandı',
    addAddressTitle: 'Adres Ekle',
    addTrackNumberTitle: 'Takip Numarası Ekle',
    trackNumberAddedSuccessfully: 'Takip numarası başarıyla eklendi',
    checkRateTitle: 'Ücreti Kontrol Et',
    originCountry: 'Çıkış Ülkesi',
    weightPerPackage: 'Paket Başına Ağırlık',
    length: 'Uzunluk',
    width: 'Genişlik',
    height: 'Yükseklik',
    destinationCountry: 'Varış Ülkesi',
    documentOption: 'Belge',
    noneDocumentOption: 'Belge Değil',
    showRateButton: 'Ücreti Göster',
    invoicesTitle: 'Faturalar',
    partialRefundInvoiceTitle: 'Kısmi İade Faturası',
    invoiceDate: 'Fatura Tarihi',
    description: 'Açıklama',
    exportOrdersTitle: 'İhracat Siparişleri',
    exportOrderDetailTitle: 'İhracat Sipariş Detayı',
    orderInfoSection: 'Sipariş Bilgisi',
    priceInfoSection: 'Fiyat Bilgisi',
    delivery: 'Teslimat',
    statusInfoSection: 'Durum Bilgisi',
    orderedAt: 'Sipariş Tarihi',
    canceledAt: 'İptal Tarihi',
    canceledBy: 'İptal Eden',
    approvedAt: 'Onay Tarihi',
    approvedBy: 'Onaylayan',
    refundedAt: 'İade Tarihi',
    refundedBy: 'İade Eden',
    sentAt: 'Gönderim Tarihi',
    receivedAt: 'Teslim Alma Tarihi',
    receivedBy: 'Teslim Alan',
    receiverInfoSection: 'Alıcı Bilgisi',
    zipCode: 'Posta Kodu',
    productDescription: 'Ürün Açıklaması',
    receiverDetail: 'Alıcı Bilgisi',
    destination: 'Varış Yeri',
    updateExportOrderTitle: 'İhracat Siparişini Güncelle',
    addExportOrderTitle: 'İhracat Siparişi Ekle',
    requestExportOrderTitle: 'İhracat Siparişi Talep Et',
    updateExportOrderTitleWithNumber: 'İhracat Siparişini Güncelle {number}',
    requestedSuccessfullyMessage: 'Başarıyla talep edildi',
    requestButton: 'Talep Et',
    updateOrderTitleWithNumber: 'Sipariş Güncelle {number}',
    requestOrderTitle: 'Sipariş Talep Et',
    dimensionsPerPackageLabel: 'Paket Başına Boyutlar',
    cancelNote: 'İptal Notu',
    approveOrderTooltip: 'Siparişi Onayla',
    volumeL: 'Hacim (U)',
    volumeW: 'Hacim (G)',
    volumeH: 'Hacim (Y)',
    fullyRefundedBadge: 'Tamamen İade Edildi',
    partiallyRefundedBadge: 'Kısmen İade Edildi',
    partiallyRefundedAt: 'Kısmi İade Tarihi',
    partiallyRefundedBy: 'Kısmi İade Eden',
    totalRefundedAmount: 'Toplam İade Edilen Tutar',
    addingBalanceWithMethod: '{method} ile Bakiye Ekleniyor',
    addingBalanceFromOffice: 'ShipZone Ofisinden Bakiye Ekleniyor',
    returningBalanceFromOffice: 'ShipZone Ofisine Bakiye İade Ediliyor',
    totalAddLabel: 'Toplam Eklenen',
    totalCashBackLabel: 'Toplam Nakit İade',
    generalTotalLabel: 'Genel Toplam',
    totalSubLabel: 'Toplam Düşülen',
    totalRefundLabel: 'Toplam İade',
    orderNoHeading: 'SİPARİŞ NO. {id}',
    expectedDateLabel: 'Beklenen Tarih',
    requestedStepLabel: 'Talep Edildi',
    deliveryStatusPrefix: 'Teslimat {status}',
    cannotUpdateTrackNumber: 'Takip numarasını güncelleyemezsiniz',
    addressIsRequired: 'Adres gereklidir',
    orderRequestedSuccessfully: 'Sipariş başarıyla talep edildi'
  },
  finance: {
    banksTitle: 'Bankalar',
    addBankTitle: 'Banka Ekle',
    updateBankTitle: 'Bankayı Güncelle',
    bankAddedSuccessfully: 'Banka başarıyla eklendi',
    bankUpdatedSuccessfully: 'Banka başarıyla güncellendi',
    filterByBank: 'Bankaya Göre Filtrele',
    filterByStatus: 'Duruma Göre Filtrele',
    filterByType: 'Türe Göre Filtrele',
    bankTransactionsTitle: 'Banka İşlemleri',
    totalAmount: 'Toplam Tutar',
    transactionDetailTitle: 'İşlem Detayı',
    transactionInfoSection: 'İşlem Bilgisi',
    classificationSection: 'Sınıflandırma',
    sourceInfoSection: 'Kaynak Bilgisi',
    datesAndStaffSection: 'Tarihler ve Personel',
    couldNotUpdateVerificationStatus: 'Doğrulama durumu güncellenemedi',
    pleaseSelectTransactionsToVerify: 'Lütfen doğrulanacak işlemleri seçin',
    verifySelectedTransactionsConfirm: 'Seçili {count} işlem doğrulansın mı?',
    transactionsVerifiedSuccessfully: 'İşlemler başarıyla doğrulandı',
    pleaseTryAgain: 'Lütfen tekrar deneyin',
    statusPaid: 'Ödendi',
    statusUnpaid: 'Ödenmedi',
    statusPending: 'Beklemede',
    statusCancel: 'İptal',
    statusRefunded: 'İade Edildi',
    statusPartialRefunded: 'Kısmi İade',
    typeOrder: 'Sipariş',
    typeMoneyTransfer: 'Para Transferi',
    typeExpense: 'Gider',
    typeCreditInvoice: 'Kredi Faturası',
    typeCashBack: 'Nakit İade',
    typeDigitalPayment: 'Dijital Ödeme',
    exchangeRatesTitle: 'Döviz Kurları',
    addExchangeRateTitle: 'Döviz Kuru Ekle',
    updateExchangeRateTitle: 'Döviz Kurunu Güncelle',
    exchangeRateAddedSuccessfully: 'Döviz kuru başarıyla eklendi',
    exchangeRateUpdatedSuccessfully: 'Döviz kuru başarıyla güncellendi',
    currencyRatesTitle: 'Para Birimi Kurları',
    addCurrencyRateTitle: 'Yeni Para Birimi Kuru Ekle',
    updateCurrencyRateTitle: 'Para Birimi Kurunu Güncelle',
    sellRateLabel: '{code} Satış Kuru (1 USD başına {code})',
    buyRateLabel: '{code} Alış Kuru (banka kuru)',
    expensesTitle: 'Giderler',
    addExpenseTitle: 'Yeni Gider Ekle',
    updateExpenseTitle: 'Gideri Güncelle',
    thereIsAnError: 'Bir hata var',
    expenseFooterNote: 'Her satır bir gider durumudur (eşleşen <strong>tüm</strong> satırların toplamı, tüm sayfalarda). Yukarıdaki tablo yalnızca geçerli sayfadır — ödenmemiş/nakit satırları görmek için sayfalama kullanın veya "sayfa başına" değerini artırın. Tarih aralığı Sermaye defter dönemiyle eşleştiğinde Sermaye "Giderler" ile eşleşmesi için ödenen + ödenmemiş + nakit toplamını kullanın.',
    received: 'Alındı',
    notReceived: 'Alınmadı',
    pleaseSelectAtLeastOneExpense: 'Lütfen en az bir gider seçin!',
    markAllSelectedExpensesReceivedConfirm: 'Bu, seçili tüm giderleri alındı olarak işaretleyecektir.',
    somethingWentWrong: 'Bir şeyler ters gitti!',
    supplierInvoiceNumberLabel: 'Tedarikçi Fatura Numarası',
    expenseTypesTitle: 'Gider Türleri',
    addExpenseTypeTitle: 'Yeni Gider Türü Ekle',
    updateExpenseTypeTitle: 'Gider Türünü Güncelle',
    capitalTitle: 'Sermaye',
    refresh: 'Yenile',
    initializeCapital: 'Sermayeyi başlat',
    depositWithdraw: 'Yatır / Çek',
    bookSummary: 'Defter özeti ({from} - {to})',
    initializedCapital: 'Başlatılan sermaye',
    totalDeposits: 'Toplam yatırılan',
    totalWithdraws: 'Toplam çekilen',
    revenueIncome: 'Gelir (kazanç)',
    netCapitalBook: 'Net sermaye (defter): {amount}',
    capitalMovements: 'Sermaye hareketleri',
    withdraw: 'Çekim',
    deposit: 'Yatırım',
    saved: 'Kaydedildi',
    couldNotSave: 'Kaydedilemedi',
    amountUsdLabel: 'Tutar (USD) *',
    depositOrWithdrawTitle: 'Yatırma veya çekme',
    adjustsCapitalBookNote: 'Yalnızca sermaye defterini ayarlar. Sistemdeki banka bakiyeleri değişmez.',
    noteOptionalLabel: 'Not (isteğe bağlı)',
    noteReasonPlaceholder: 'Bu hareket için sebep veya referans',
    noteShownHint: 'Girilirse hareket listesinde gösterilir.',
    depositAddToCapitalBook: 'Yatırma (sermaye defterine ekle)',
    withdrawSubtractFromCapitalBook: 'Çekme (sermaye defterinden düş)',
    enterValidAmountError: 'Geçerli bir tutar girin (en az 0.01).',
    moneyTransfersTitle: 'Para Transferleri',
    transferMoneyTitle: 'Para Transferi',
    doneSuccessfully: 'Başarıyla tamamlandı'
  },
  login: {
    brandName: 'Las Shopping',
    welcomeBack: 'Tekrar Hoş Geldiniz!',
    signInToContinue: 'Devam etmek için giriş yapın',
    phoneNumber: 'Telefon Numarası',
    password: 'Şifre',
    loginButton: 'Giriş Yap',
    noAccount: 'Hesabınız yok mu?',
    signUp: 'Kayıt Ol',
    adminLoginTitle: 'Yönetici Girişi',
    adminSignInSubtitle: 'Personel hesabınıza giriş yapın',
    email: 'E-posta'
  },
  signup: {
    createAccountTitle: 'Hesap Oluştur',
    step1Hint: 'Doğrulama kodu almak için telefon numaranızı girin.',
    sendCodeButton: 'Kod Gönder',
    alreadyHaveAccount: 'Zaten bir hesabınız var mı?',
    signInLink: 'Giriş yap',
    otpSentHintPrefix: 'Şu numaraya gönderilen doğrulama kodunu girin:',
    verificationCodeLabel: 'Doğrulama Kodu',
    backButton: '← Geri',
    verifyButton: 'Doğrula',
    step3Hint: 'Kaydı tamamlamak için profilinizi doldurun.',
    fullNameHint: 'En az ad ve soyad girin',
    dateOfBirthLabel: 'Doğum Tarihi',
    passwordMinCharsHint: 'En az 6 karakter',
    emailOptionalLabel: 'E-posta (isteğe bağlı)',
    genderOptionalLabel: 'Cinsiyet (isteğe bağlı)',
    maleOption: 'Erkek',
    femaleOption: 'Kadın',
    deliveryAddressOptional: 'Teslimat Adresi',
    optionalLabel: '(isteğe bağlı)',
    addressSectionHint: 'Gelecekteki siparişleri hızlandırmaya yardımcı olur',
    addressTypeLabel: 'Adres Türü',
    houseNumberLabel: 'Ev Numarası',
    floorOptionalLabel: 'Kat (isteğe bağlı)',
    streetLabel: 'Sokak',
    buildingNameLabel: 'Bina Adı',
    apartmentNumberLabel: 'Daire Numarası',
    floorLabel: 'Kat',
    companyLabel: 'Şirket',
    addressPhoneNumberOptional: 'Adres Telefon Numarası (isteğe bağlı)',
    additionalDirectionsOptional: 'Ek Yönergeler (isteğe bağlı)',
    addressLabelHint: 'Adres Etiketi (ör. Ev, İş)',
    createAccountButton: 'Hesap Oluştur',
    houseType: 'Ev',
    apartmentType: 'Daire',
    officeType: 'Ofis',
    validPhoneRequiredError: 'Lütfen geçerli bir telefon numarası girin',
    failedToSendCodeError: 'Kod gönderilemedi',
    verificationCodeRequiredError: 'Lütfen doğrulama kodunu girin',
    verificationFailedError: 'Doğrulama başarısız oldu',
    fullNameRequiredError: 'Ad soyad gereklidir',
    dobRequiredError: 'Doğum tarihi gereklidir',
    passwordMinLengthError: 'Şifre en az 6 karakter olmalıdır',
    confirmPasswordRequiredError: 'Lütfen şifrenizi onaylayın',
    passwordsDoNotMatchError: 'Şifreler eşleşmiyor',
    validEmailRequiredError: 'Lütfen geçerli bir e-posta adresi girin',
    addressTypeRequiredError: 'Adres türü gereklidir',
    addressLabelRequiredError: 'Adres etiketi gereklidir (ör. Ev)',
    welcomeTitle: 'Hoş geldiniz!',
    accountCreatedSuccessfully: 'Hesabınız başarıyla oluşturuldu.',
    registrationFailedTitle: 'Kayıt Başarısız',
    verifyAccountTitle: 'Hesabınızı doğrulayın',
    nextButton: 'İleri',
    congratulationsTitle: 'Tebrikler!',
    accountVerifiedSuccessfully: 'Hesabınız başarıyla doğrulandı.',
    backToHomeButton: 'Ana Sayfaya Dön'
  },
  statistics: {
    fromDateLabel: 'Başlangıç Tarihi',
    toDateLabel: 'Bitiş Tarihi',
    chartTypeLabel: 'Grafik Türü',
    barChartOption: 'Çubuk Grafik',
    pieChartOption: 'Pasta Grafik',
    doughnutChartOption: 'Halka Grafik',
    lineChartOption: 'Çizgi Grafik',
    applyButton: 'Uygula',
    loadingStatisticsText: 'İstatistikler yükleniyor...',
    selectDateRangeHint: 'Grafikleri yüklemek için bir tarih aralığı seçin ve Uygula\'ya tıklayın.',
    noDataFoundHint: 'Seçili tarih aralığı için veri bulunamadı.',
    fullScreenTitle: 'Tam ekran',
    topCustomersByOrderCount: 'Sipariş Sayısına Göre İlk 10 Müşteri',
    topCustomersByRevenue: 'Gelire Göre İlk 10 Müşteri ($)',
    revenueUsdLabel: 'Gelir ($)',
    topWebsitesByOrders: 'Siparişlere Göre İlk 10 Web Sitesi',
    topWarehousesByOrders: 'Siparişlere Göre İlk 10 Depo',
    topProductsByOrders: 'Siparişlere Göre İlk 10 Ürün',
    topBrandsByOrders: 'Siparişlere Göre İlk 10 Marka',
    orderStatusDistribution: 'Sipariş Durumu Dağılımı',
    topItemTypesByOrders: 'Siparişlere Göre İlk 10 Ürün Türü',
    monthlyOrderTrend: 'Aylık Sipariş Eğilimi',
    pleaseSelectFromToDate: 'Lütfen Başlangıç Tarihi ve Bitiş Tarihi seçin.',
    failedToLoadStatistics: 'İstatistikler yüklenemedi.'
  },
  linkRules: {
    updateLinkRuleTitle: 'Bağlantı Kuralını Güncelle',
    addNewLinkRuleTitle: 'Yeni Bağlantı Kuralı Ekle',
    nameHint: "Yönetici etiketi, örn. 'Trendyol'",
    testUrlLabel: 'Test URL',
    testUrlHint: 'Bu siteden gerçek bir örnek ürün URL\'si yapıştırın. Alan adı ve aşağıdaki önizleme bundan türetilir.',
    domainHint: 'URL ana bilgisayarına karşı alt dize olarak eşleştirilir, örn. trendyol.com',
    shortLinkCheckboxLabel: 'Bu kısa bir bağlantı (yönlendirme, örn. ty.gl)',
    searchByNameOrDomainPlaceholder: 'İsme veya alan adına göre ara...',
    shortLinkColumn: 'Kısa Bağlantı',
    priorityColumn: 'Öncelik',
    resolveButton: 'Çöz',
    resolvesToLabel: 'Şuna çözülür:',
    detectedAsProductPage: '✅ Ürün sayfası olarak algılandı',
    notDetectedAsProductPage: '❌ Ürün sayfası olarak algılanmadı',
    previewExtractedNameLabel: 'Çıkarılan ad önizlemesi:',
    hideAdvancedOptions: 'Gelişmiş seçenekleri gizle',
    advancedOptionsHint: 'Gelişmiş seçenekler (yalnızca yukarıdaki önizleme yanlışsa gereklidir)',
    productPageMatchTypeLabel: 'Ürün sayfası eşleşme türü',
    productPagePatternLabel: 'Ürün sayfası deseni',
    productPagePatternHint: 'Yol alt dizesi (içerir) veya regex',
    excludePathPrefixesLabel: 'Hariç tutulacak yol önekleri',
    excludePathPrefixesHint: 'Virgülle ayrılmış, bu alan adı için varsayılan sepet/ödeme/vb. hariç tutma listesini geçersiz kılar',
    nameExtractionTypeLabel: 'Ad çıkarma türü',
    nameExtractionPatternLabel: 'Ad çıkarma deseni',
    nameExtractionPatternHint: 'Bir yakalama grubuna sahip regex veya bir sorgu parametresi anahtarı',
    nameCleanupRegexLabel: 'Ad temizleme regex\'i',
    nameCleanupRegexHint: 'İsteğe bağlı: çıkarmadan sonra uygulanan ekstra sondaki ek temizleyici',
    priorityLabel: 'Öncelik',
    priorityHint: 'Birden fazla kural eşleşebiliyorsa önce düşük olan çalışır',
    notesLabel: 'Notlar',
    containsPathSubstringOption: 'İçerir (yol alt dizesi)',
    regexOption: 'Regex',
    regexCaptureGroupOption: 'Regex (yakalama grubu 1)',
    queryParameterOption: 'Sorgu parametresi',
    couldNotResolveUrl: 'Bu URL çözülemedi'
  },
  qrLabels: {
    driverLabel: 'Sürücü',
    productLabel: 'Ürün',
    printLabelDriverButton: 'Etiketi Yazdır (Sürücü)',
    printLabelOrderIdButton: 'Etiketi Yazdır (Sipariş No)',
    failedToGenerateQrCode: 'QR kodu oluşturulamadı',
    failedToAdvanceToIntShipment: 'Siparişler Uluslararası Sevkiyata ilerletilemedi'
  },
  datatable: {
    newOrderButton: 'Yeni Sipariş',
    reloadTableButton: 'Tabloyu Yenile',
    toggleButtonDisplayTooltip: 'Buton etiketlerini göster/gizle',
    exportButton: 'Dışa Aktar',
    prepareToPrintButton: 'Yazdırmaya hazırla',
    fastPaymentButton: 'Hızlı Ödeme',
    mergeAndPrintButton: 'Birleştir ve Yazdır',
    receiveButton: 'Al',
    unreceiveButton: 'Almayı Geri Al',
    printReceiveButton: 'Alındıyı Yazdır',
    outOfficeButton: 'Ofis Dışı',
    addNewButton: 'Yeni Ekle',
    generateQrCodeButton: 'QR Kodu Oluştur',
    generateInvoiceButton: 'Fatura Oluştur',
    attachToDeliveryButton: 'Teslimata Ekle',
    changeStatusButton: 'Durumu Değiştir',
    deliverySummaryButton: 'Teslimat Özeti',
    unclearButton: 'Belirsizi Kaldır',
    reloadShortLabel: 'Yenile',
    qrCodeShortLabel: 'QR Kod',
    invoiceShortLabel: 'Fatura',
    statusShortLabel: 'Durum',
    summaryShortLabel: 'Teslimat',
    prepareToPrintShortLabel: 'Yazdır',
    fastPaymentShortLabel: 'Hızlı Öde',
    mergeAndPrintShortLabel: 'Birleştir',
    printReceiveShortLabel: 'Alındı Yazdır',
    sendAllToCustomerShortLabel: 'Tümünü Gönder',
    secondInvoiceShortLabel: '2. Fatura',
    generateSecondInvoiceButton: '2. Faturayı Oluştur',
    deliveryInvoiceButton: 'Teslimat Faturası',
    sendToWarehouseButton: 'Depoya Gönder',
    sendToPendingShipmentButton: 'Bekleyen Sevkiyata Gönder',
    sendAllToPendingShipmentButton: 'Tümünü Bekleyen Sevkiyata Gönder',
    sendToShipmentButton: 'Sevkiyata Gönder',
    sendAllToShipmentButton: 'Tümünü Sevkiyata Gönder',
    newShiponlyButton: 'Yeni Sadece Kargo',
    sendToPendingToBranchButton: 'Bekleyen Şubeye Gönder',
    sendToBranchButton: 'Şubeye Gönder',
    sendAllToBranchButton: 'Tümünü Şubeye Gönder',
    sendToBranchDeliveryButton: 'Şube Teslimatına Gönder',
    sendToCustomerButton: 'Müşteriye Gönder',
    sendAllToCustomerButton: 'Tümünü Müşteriye Gönder',
    addStaffButton: 'Personel Ekle',
    approveAllShiponlyButton: 'Tüm Sadece Kargoyu Onayla',
    bulkOrdersButton: 'Toplu Siparişler',
    sendAllToProcessButton: 'Tümünü İşleme Gönder',
    cashBackButton: 'Nakit İade',
    addCreditButton: 'Kredi Ekle',
    addWarehouseButton: 'Depo Ekle',
    addCustomerButton: 'MÜŞTERİ EKLE',
    generateCouponButton: 'Kupon Oluştur',
    addBankButton: 'Banka Ekle',
    addSupplierButton: 'Tedarikçi Ekle',
    addExpenseTypeButton: 'Gider Türü Ekle',
    addNewExpenseButton: 'Yeni Gider Ekle',
    addNewCityButton: 'Yeni Şehir Ekle',
    updateCityTitle: 'Şehri Güncelle',
    updateAboutTitle: 'Hakkında Güncelle',
    addNewAboutTitle: 'Yeni Hakkında Ekle',
    updateSupplierTitle: 'Tedarikçiyi Güncelle',
    addNewSupplierTitle: 'Yeni Tedarikçi Ekle',
    addGovernorateButton: 'İl Ekle',
    addNewReasonButton: 'Yeni Neden Ekle',
    updateReasonTitle: 'Nedeni Güncelle',
    addNewAboutAppButton: 'Yeni Uygulama Hakkında Ekle',
    addNewHelpCenterButton: 'Yeni Yardım Merkezi Ekle',
    addNewRoleButton: 'Yeni Rol Ekle',
    updateRoleTitle: 'Rolü Güncelle',
    deleteSelectedSubscriptionButton: 'Seçili Aboneliği Sil',
    addNewCustomerSubscriptionButton: 'Yeni Müşteri Aboneliği Ekle',
    permanentlyDeleteSelectedOrdersButton: 'Seçili Siparişleri Kalıcı Olarak Sil',
    addNewBranchButton: 'Yeni Şube Ekle',
    branchesTitle: 'Şubeler',
    updateBranchTitle: 'Şubeyi Güncelle',
    addMoneyButtonDefault: 'Bakiye Ekle',
    transferMoneyButton: 'Para Transferi',
    addExchangeRateButton: 'Döviz Kuru Ekle',
    requestDeliveryButton: 'Teslimat Talep Et',
    applyFilterTooltip: 'Filtre Uygula',
    cancelFilterTooltip: 'Filtreyi İptal Et',
    showHideColumnsLabel: 'Sütunları Göster/Gizle',
    pleaseSelectWarehouseHint: 'Lütfen depo seçin',
    pleaseSelectBothDatesError: 'Lütfen her iki tarihi de seçin!',
    chooseOption: 'Seç',
    orderOption: 'Sipariş',
    usaOption: 'ABD',
    chinaOption: 'Çin',
    uaeOption: 'BAE',
    partialReceivedOption: 'Kısmi Alındı'
  },
  printLogs: {
    title: 'Yazdırma Kayıtları',
    subtitle: 'Yazdırılan tüm faturaları takip edin',
    printButton: 'Yazdır',
    printAllButton: 'Tümünü yazdır',
    fromLabel: 'Başlangıç',
    toLabel: 'Bitiş',
    typeLabel: 'Tür',
    allTypesOption: 'Tüm Türler',
    secondShippingOption: '2. Kargo',
    printedByLabel: 'Yazdıran',
    allStaffOption: 'Tüm Personel',
    filterButton: 'Filtrele',
    todayButton: 'Bugün',
    totalEntries: 'Toplam Kayıt',
    totalAmountLabel: 'Toplam Tutar',
    firstPrints: 'İlk Baskılar',
    reprints: 'Yeniden Baskılar',
    loadingLogsText: 'Kayıtlar yükleniyor...',
    noPrintsFoundTitle: 'Baskı Bulunamadı',
    noPrintsFoundBetween: '{from} ile {to} arasında yazdırılan fatura yok.',
    timeColumn: 'Saat',
    reprintBadge: 'Yeniden Baskı ×{count}',
    firstPrintBadge: 'İlk Baskı',
    viewOnlyBadge: 'Yalnızca Görüntüleme',
    viewOnlyTooltip: 'Fatura Görüntüle düğmesinden yazdırıldı — ödeme kanıtı değildir',
    deliveryPrintTooltip: 'Teslimat düğmesiyle yazdırıldı — müşterinin teslimat talebine eklendi',
    saveAndViewBadge: 'Kaydet ve Görüntüle',
    saveAndViewTooltip: 'Kaydet ve görüntüle ile yazdırıldı — kaydedilen faturanın resmi bir kopyası',
    totalLabel: 'Toplam',
    printPageTitle: 'Yazdırma Kayıtları — {from} - {to}'
  },
  profit: {
    title: 'Kâr',
    totalInternationalShipment: 'Toplam Uluslararası Sevkiyat',
    totalShippingInvoiceShipment: 'Toplam Sevkiyat Faturası Sevkiyatı',
    totalLocalTax: 'Toplam Yerel Vergi',
    totalFee: 'Toplam Ücret',
    totalRefund: 'Toplam İade',
    totalIncome: 'Toplam Gelir',
    totalExpense: 'Toplam Gider'
  },
  driverDeliver: {
    loadingOrderDetails: 'Sipariş detayları yükleniyor...',
    orderMovedTitle: 'Sipariş Şube Teslimatına Taşındı!',
    orderMovedMessage: '#{id} numaralı sipariş Şube Teslimatına taşındı.',
    alreadyAtBranchTitle: 'Zaten Şubede',
    alreadyAtBranchMessage: 'Bu sipariş zaten Şube Teslimatına taşınmış.',
    cannotProcessTitle: 'İşlenemez',
    wrongStatusMessage: 'Bu sipariş Uluslararası Sevkiyat aşamasında değil. Mevcut durum:',
    orderNumberLabel: '#{id} Numaralı Sipariş',
    naLabel: 'Yok',
    areaLabel: 'Bölge',
    houseBuildingLabel: 'Ev / Bina',
    deliveryPhoneLabel: 'Teslimat Telefonu',
    tapToMoveButton: 'Şube Teslimatına Taşımak İçin Dokun',
    processingButton: 'İşleniyor...',
    unknownStatus: 'Bilinmiyor',
    failedToLoadOrder: 'Sipariş yüklenemedi',
    failedToLoadOrderDetails: 'Sipariş detayları yüklenemedi',
    failedToProcessOrder: 'Sipariş işlenemedi'
  },
  addEditGovernorate: {
    updateTitle: 'İli Güncelle',
    addTitle: 'Yeni İl Ekle',
    governorateNameLabel: 'İl Adı',
    governorateNameArLabel: 'İl Adı (Arapça)',
    governorateNameKuLabel: 'İl Adı (Kürtçe)'
  },
  cashBack: {
    title: 'Kredi Nakit İadesi',
    cashedBackSuccessfully: 'Kredi başarıyla nakit olarak iade edildi',
    amountMoreThanCreditError: 'Nakit iade tutarı müşteri kredisinden fazla',
    editTitle: 'Nakit İadeyi Düzenle',
    updatedSuccessfully: 'Nakit iade başarıyla güncellendi'
  },
  generateCoupon: {
    couponsGeneratedSuccessfully: 'Kuponlar Başarıyla Oluşturuldu',
    couponsUpdatedSuccessfully: 'Kuponlar Başarıyla Güncellendi',
    numberOfCouponLabel: 'Kupon sayısı',
    discountPercentageLabel: 'İndirim yüzdesi',
    expireDateLabel: 'Son Kullanma Tarihi',
    generateButton: 'Oluştur',
    pleaseDetermineExpireDate: 'Lütfen Son Kullanma Tarihini belirleyin',
    expireDateMustBeGreaterThanToday: 'Son Kullanma Tarihi bugünden sonra olmalıdır'
  },
  partialRefundingOrder: {
    title: 'Kısmi İade',
    orderTotalAmountLabel: 'Sipariş Toplam tutarı ${amount}'
  },
  addEditOrderCase: {
    updateTitle: 'Sipariş Vakasını Güncelle',
    addTitle: 'Yeni Sipariş Vakası Ekle',
    orderIdColon: 'Sipariş Kimliği:',
    imagesTitle: 'Sipariş Vakası Görselleri'
  },
  addEditNotFoundOrder: {
    updateTitle: 'Bulunamayan Siparişi Güncelle',
    addTitle: 'Yeni Bulunamayan Sipariş Ekle',
    updatedTitle: 'Güncellendi'
  },
  adminCancelOrder: {
    orderCanceledSuccessfully: 'Sipariş başarıyla iptal edildi',
    willAutoRefundPrefix: 'Bu sipariş zaten satın alındı. İptal edilmesi otomatik olarak tam iade de verecektir',
    ofUpToAmount: ' en fazla ${amount} tutarında',
    willAutoRefundTail: " müşterinin kredi bakiyesine. Kesin tutar, daha önce verilmiş kısmi iadeleri de hesaba katacaktır.",
    cancelReasonListLabel: 'İptal nedeni listesi',
    cancelReasonEnglishLabel: 'İptal nedeni İngilizce',
    cancelReasonArabicLabel: 'İptal nedeni Arapça',
    cancelReasonKurdishLabel: 'İptal nedeni Kürtçe'
  },
  globalWebsiteGroupModal: {
    updateGroupTitle: 'Grubu Güncelle',
    addNewGroupTitle: 'Yeni Grup Ekle',
    sitesButton: 'Siteler'
  },
  recordInvoicePayment: {
    title: 'Ödemeyi Kaydet',
    invoiceHashLabel: 'Fatura #',
    walletBalanceCheckboxLabel: 'Müşterinin bu tutar zaten cüzdan bakiyesinde var (örn. FIB/QI/ofis bakiye yüklemesinden) — tekrar kredi eklemeden uygula',
    balanceOption: 'Bakiye',
    availableTitle: 'Bu müşterinin {amount} kullanılabilir bakiyesi var',
    useBalance: 'Bakiyeyi kullan',
    unknownSource: 'kaynak belirlenemedi',
    balanceHint: '"Bakiye" asla para eklemez — müşterinin zaten sahip olduğundan öder.',
    balanceButton: 'Bakiye',
    payButton: 'Öde'
  },
  addEditUserSubscription: {
    customerSubscriptionTitle: 'Müşteri Aboneliği',
    deleteAllSelectedConfirm: 'Seçilen tüm kullanıcı abonelikleri silinsin mi?'
  },
  orderDeliveryCustomerImages: {
    title: 'Müşteri Siparişleri ve Görseller',
    noOrdersFound: 'Bu müşteri için sipariş bulunamadı.',
    productLabel: 'Ürün',
    imagesLabel: 'Görseller',
    notInvoiced: 'Faturalanmadı'
  },
  viewOrderDates: {
    pendingAnswerDateLabel: 'Bekleyen Yanıt Tarihi',
    processDateLabel: 'İşlem Tarihi',
    cancelDateLabel: 'İptal Tarihi',
    approveDateLabel: 'Onay Tarihi',
    refundDateLabel: 'İade Tarihi',
    pendingShipmentDateLabel: 'Bekleyen Sevkiyat Tarihi',
    shipmentDateLabel: 'Sevkiyat Tarihi',
    deliveredDateLabel: 'Teslim Tarihi'
  },
  refundingOrder: {
    title: 'Siparişi İade Et',
    sendSmsLabel: 'SMS Gönder',
    orderTotalRemainAmountLabel: 'Sipariş Toplam kalan tutarı ${amount}'
  },
  assignPermission: {
    titleWithRole: '[{role}] rolüne izin ata',
    savedSuccessfully: 'Başarıyla kaydedildi',
    checkAllLabel: 'Tümünü seç'
  },
  purchaseOrder: {
    titleWithId: 'Sipariş Satın Al {id}',
    costBreakdownByWarehouse: 'Depoya Göre Maliyet Dağılımı',
    ordersSelectedLabel: '{count} sipariş seçildi',
    actualPriceLabel: 'Gerçek Fiyat',
    actualPriceRequiredError: 'Gerçek Fiyat gereklidir',
    mustBeValidNumberError: 'Geçerli bir sayı olmalıdır'
  },
  reassignCustomer: {
    reassignCustomerTooltip: 'Müşteriyi Yeniden Ata',
    chargedToLabel: 'Bu sipariş şu anda şu kişiye borçlandırılmış:',
    pickingDifferentCustomerText: 'Aşağıdan farklı bir müşteri seçmek {name} için iade yapacak, bu siparişin sevkiyat faturasını silecek ve seçilen müşteriye aynı tutar (${amount}) için yeni bir fatura kesecektir.',
    newCustomerLabel: 'Yeni Müşteri* (isim veya telefon ile ara)',
    telPrefix: ' - Tel: ',
    failedToLoadCustomers: 'Müşteriler yüklenemedi',
    selectedCustomerFallback: 'seçilen müşteri',
    confirmReassignText: 'Bu, {name} için iade yapacak, bu siparişin sevkiyat faturasını silecek ve {newName} kişisine ${amount} tutarında yeni bir fatura kesecektir. Devam edilsin mi?',
    failedToReassignCustomer: 'Müşteri yeniden atanamadı'
  },
  createCredit: {
    creditAddedSuccessfully: 'Kredi başarıyla eklendi',
    amountUsdLabel: 'Tutar USD',
    amountIqdLabel: 'Tutar IQD',
    autoInvoiceLabel: 'Henüz faturası olmayan kargolanmış siparişler için otomatik fatura oluştur (bu işareti kaldırmak yalnızca yeni bir fatura oluşturmayı atlar — bu bakiye yüklemesi yine de mevcut bir faturayı öder)'
  },
  helpCenter: {
    updateTitle: 'Yardım Merkezini Güncelle',
    questionEnLabel: 'Soru (İngilizce)',
    questionArLabel: 'Soru (Arapça)',
    questionKuLabel: 'Soru (Kürtçe)',
    answerEnLabel: 'Cevap (İngilizce)',
    answerArLabel: 'Cevap (Arapça)',
    answerKuLabel: 'Cevap (Kürtçe)',
    isActiveLabel: 'Aktif',
    answerEnRequiredError: 'Cevap (İngilizce) gereklidir',
    displayLanguageLabel: 'Görüntüleme Dili',
    englishEnOption: 'İngilizce (en)',
    arabicArOption: 'Arapça (ar)',
    kurdishKuOption: 'Kürtçe (ku)'
  },
  processExportOrder: {
    title: 'İhracat Siparişini İşle',
    orderNoColon: 'Sipariş No.:'
  },
  customerDeliverySummary: {
    title: 'Müşteri Teslimat Özeti',
    clearButton: 'Temizle',
    loadingAllOrders: 'Eşleşen tüm siparişler yükleniyor…',
    totalCustomerLabel: 'Toplam Müşteri',
    totalOrdersLabel: 'Toplam Sipariş',
    requestReceivedLabel: 'Alınan Talep',
    dateReceivedLabel: 'Alınma Tarihi',
    timeLabel: 'Saat',
    confirmClearOrdersText: '{count} sipariş temizlendi olarak işaretlensin mi? Artık varsayılan olarak bu listede görünmeyecekler.',
    failedToClearOrders: 'Siparişler temizlenemedi'
  },
  adminDashboard: {
    title: 'Kontrol Paneli',
    updatedAtLabel: 'Güncellendi {time}',
    refreshButton: 'Yenile',
    loadingDashboardText: 'Kontrol paneli yükleniyor...',
    orderIntakeSection: 'Sipariş Alımı',
    processingSection: 'İşleniyor',
    fulfillmentSection: 'Tamamlama',
    deliveryCompletionSection: 'Teslimat ve Tamamlanma',
    pendingAnswerLabel: 'Yanıt Bekliyor',
    processedLabel: 'İşlendi',
    ordersTodayLabel: 'Bugünkü Siparişler',
    pendingPaymentsLabel: 'Bekleyen Ödemeler',
    purchasedLabel: 'Satın Alındı',
    warehouseDeliveredLabel: 'Depoya Teslim Edildi',
    intShipmentLabel: 'Uluslararası Sevkiyat',
    pendingToBranchLabel: 'Şubeye Bekliyor',
    branchDeliveryLabel: 'Şube Teslimatı',
    deliveredLabel: 'Teslim Edildi',
    kurdistanBalance: 'Kürdistan Bakiyesi',
    usaBalance: 'ABD Bakiyesi',
    customersOweUs: 'Müşteri Borcu',
    weOweCustomers: 'Müşteriye Borcumuz',
    supplierLoan: 'Tedarikçi Kredisi',
    totalCapital: 'Toplam Sermaye'
  },
  homeSlider: {
    updateTitle: 'Ana Sayfa Kaydırıcısını Güncelle',
    addTitle: 'Yeni Ana Sayfa Kaydırıcısı Ekle'
  },
  editOrderCharge: {
    editChargeTooltip: 'Ücreti Düzenle',
    editChargeTitle: 'Ücreti Düzenle',
    alreadyChargedHint: 'Bu sipariş zaten ücretlendirildi. Aşağıdaki toplamı değiştirmek, farkı müşterinin bakiyesinden otomatik olarak borç/alacak olarak kaydedecektir.',
    itemPriceUsdLabel: 'Ürün Fiyatı ($)',
    shippingUsdLabel: 'Kargo ($)',
    discountUsdLabel: 'İndirim ($)',
    newTotalLabel: 'Yeni Toplam:',
    wasLabel: '(önceki ${amount})',
    failedToLoadOrderDetails: 'Sipariş detayları yüklenemedi',
    increaseWithBalanceText: 'Toplam ${from} tutarından ${to} tutarına yükselecek (+${diff}). ${diff} müşterinin bakiyesinden düşülecek. Devam edilsin mi?',
    increaseInsufficientBalanceText: 'Toplam ${from} tutarından ${to} tutarına yükselecek (+${diff}). Müşterinin bakiyesi yetersiz olabilir — bunun yerine bir not kaydedilecek. Devam edilsin mi?',
    decreaseText: 'Toplam ${from} tutarından ${to} tutarına düşecek (-${diff}). ${diff} müşterinin bakiyesine geri iade edilecek. Devam edilsin mi?',
    orderUpdatedTitle: 'Sipariş Güncellendi',
    failedToUpdateOrder: 'Sipariş güncellenemedi'
  },
  refundExportOrder: {
    fullRefundTitle: 'İhracat Siparişi Tam İadesi',
    partialRefundTitle: 'İhracat Siparişi Kısmi İadesi',
    refundedSuccessfully: 'Sipariş başarıyla iade edildi',
    orderTotalAmountLabel: 'Sipariş Toplam tutarı ${amount}',
    alreadyRefundedLabel: 'Zaten İade Edilen: ${amount}',
    moneyAmountLabel: 'Para tutarı',
    refundNoteLabel: 'İade notu',
    confirmRefundText: 'Bu, müşterinin kredisine ${amount} iade edecektir.',
    validRefundAmountError: 'Lütfen geçerli bir iade tutarı girin',
    amountExceedsRemainingError: 'Tutar kalan tutarı aşamaz: ${amount}',
    partialLessThanRemainingError: 'Kısmi iade, kalan tutardan az olmalıdır: ${amount}',
    refundReasonRequiredError: 'Tam iadeler için iade nedeni gereklidir',
    fullRefundProcessedSuccessfully: 'Tam iade başarıyla işlendi',
    partialRefundProcessedSuccessfully: 'Kısmi iade başarıyla işlendi',
    failedToProcessRefund: 'İade işlenemedi'
  },
  secret: {
    greetingHi: 'Merhaba {name}',
    enterSecretKeyHint: 'Bu bölümü görmek için Gizli Anahtarınızı girmeniz gerekir',
    dontHaveSecretKey: 'Gizli Anahtarınız yok mu?',
    letMeInButton: 'Girmeme izin ver',
    confirmSecretKeyLabel: 'Gizli Anahtarı Onayla'
  },
  viewOrderUsers: {
    orderedBy: 'Sipariş Veren',
    shipOnlyBy: 'Sadece Kargolayan',
    pendingAnsweredBy: 'Yanıtlayan',
    processedBy: 'İşleyen',
    warehousedBy: 'Depoya Alan',
    pendingShippedBy: 'Bekleyen Sevkiyatı Yapan',
    shippedBy: 'Sevk Eden',
    pendingToBranchBy: 'Şubeye Bekleyen Gönderen',
    brandDeliveredBy: 'Şubeye Teslim Eden',
    deliveredBy: 'Teslim Eden',
    archivedBy: 'Arşivleyen'
  },
  home: {
    welcomeTitle: 'Lasshopping\'e Hoş Geldiniz',
    pleaseFillOutInfo: 'Lütfen bu bilgileri doldurun',
    processWasSuccessful: 'İşlem başarılı oldu',
    realEmailHint: 'E-posta gerçek bir e-posta olmalıdır, çünkü siparişinizle ilgili tüm işlemler bu e-postaya gönderilecektir'
  },
  forceUpdate: {
    updateTitle: 'Zorunlu Güncellemeyi Güncelle',
    addTitle: 'Yeni Zorunlu Güncelleme Ekle',
    minBuildNumberLabel: 'Gerekli Minimum Yapı Numarası',
    minBuildNumberHint: 'Bu yapı numarasının altındaki yüklü uygulamalar güncellemeye zorlanacaktır.',
    operatingSystemLabel: 'İşletim Sistemi',
    imageMustBeImageError: 'Dosya türü resim olmalıdır',
    minBuildNumberColumn: 'Min. Yapı Numarası',
    softUpdateType: 'Yumuşak',
    hardUpdateType: 'Zorunlu'
  },
  editCredit: {
    title: 'Krediyi Düzenle',
    updatedSuccessfully: 'Kredi başarıyla güncellendi'
  },
  addEditSubscription: {
    addTitle: 'Abonelik Ekle',
    addNewButton: 'Yeni Abonelik Ekle',
    nameLabel: 'Abonelik Adı',
    deleteSubscriptionConfirm: 'Abonelik silinsin mi: {name}?',
    deleteUserSubscriptionConfirm: 'Kullanıcı aboneliği silinsin mi: {name}?'
  },
  addEditOrderType: {
    addTitle: 'Sipariş Türü Ekle',
    nameLabel: 'Tür Adı',
    addNewButton: 'Yeni Sipariş Türü Ekle'
  },
  prepareToPrint: {
    arrivedDateLabel: 'Varış tarihi:',
    signatureLabel: 'İmza'
  },
  exportOrder: {
    cancelTitle: 'Dışa Aktarma Siparişini İptal Et'
  },
  editTransportationType: {
    title: 'Nakliye Türünü Düzenle'
  },
  invoicePaymentLogs: {
    title: 'Ödeme Kayıtları',
    paidAfterColumn: 'Sonrası Ödenen',
    remainingAfterColumn: 'Sonrası Kalan',
    noPaymentsRecordedYet: 'Henüz kayıtlı ödeme yok'
  },
  editProductName: {
    title: 'Ürün Adını Düzenle',
    updatedSuccessfully: 'Ürün adı başarıyla güncellendi'
  },
  sendToWarehouse: {
    title: 'Siparişi depoya gönder'
  },
  sendToShipment: {
    title: 'Siparişi sevkiyata gönder'
  },
  sendNotification: {
    title: 'Bildirim Gönder',
    sendToAllLabel: 'Herkese Gönder',
    sendToDeliveredLabel: 'Teslim Edilen Sipariş Müşterilerine Gönder',
    selectCustomerLabel: 'Müşteri Seç',
    bodyLabel: 'İçerik',
    historyTitle: 'Önceden Gönderilenler',
    historyEmptyLabel: 'Henüz bildirim gönderilmedi',
    useAgainTooltip: 'Bu mesajı kullan',
    audienceAllLabel: 'Tüm müşteriler',
    audienceDeliveredOnlyLabel: 'Teslim edilen sipariş müşterileri',
    audienceCustomSuffix: 'müşteri',
    recipientsLabel: 'Alıcılar'
  },
  ourAddress: {
    searchPlaceholder: 'Ara...',
    transByColumn: 'Nakliye Türü',
    ourAddressesTitle: 'Adreslerimiz'
  },
  homeBanner: {
    isCounterLabel: 'Sayaç mı',
    titleArabicLabel: 'Başlık Arapça',
    titleKurdishLabel: 'Başlık Kürtçe',
    descriptionArabicLabel: 'Açıklama Arapça',
    descriptionKurdishLabel: 'Açıklama Kürtçe',
    startDateLabel: 'Başlangıç Tarihi',
    endDateLabel: 'Bitiş Tarihi',
    colorDarkLabel: 'Koyu Renk',
    backgroundColorLabel: 'Arka Plan Rengi',
    backgroundColorDarkLabel: 'Koyu Arka Plan Rengi',
    titleRequiredError: 'Başlık gereklidir',
    titleArabicRequiredError: 'Arapça başlık gereklidir',
    titleKurdishRequiredError: 'Kürtçe başlık gereklidir',
    startDateRequiredError: 'Başlangıç tarihi gereklidir',
    endDateRequiredError: 'Bitiş tarihi gereklidir',
    endDateAfterStartDateError: 'Bitiş tarihi başlangıç tarihinden sonra olmalıdır',
    colorHexError: 'Renk geçerli bir onaltılık renk kodu olmalıdır',
    descriptionRequiredError: 'Açıklama gereklidir',
    descriptionArabicRequiredError: 'Arapça açıklama gereklidir',
    descriptionKurdishRequiredError: 'Kürtçe açıklama gereklidir'
  },
  customerPrices: {
    updatedSuccessfully: 'Müşteri fiyatları başarıyla güncellendi',
    baseQttChargeUsaLabel: 'Temel Miktar Ücreti (ABD)',
    otherQttChargeUsaLabel: 'Diğer Miktar Ücreti (ABD)'
  },
  kreenexFeePrices: {
    updatedSuccessfully: 'ShipZone ücret fiyatları başarıyla güncellendi',
    feePercentageLabel: 'ShipZone ücret yüzdesi',
    feeBaseUsaLabel: 'ShipZone ücret tabanı (ABD)',
    feeUsaLabel: 'ShipZone ücreti (ABD)',
    explanationInPrefix: 'İçinde',
    explanationIfLessThan: 'eğer',
    explanationLessThan: 'küçükse',
    explanationWillBe: 'olacak',
    explanationOtherwise: ', Aksi halde',
    explanationFormula: 'ShipZone ücreti (usa) + (item_price * ShipZone ücret yüzdesi)'
  },
  orderStatusSettings: {
    title: 'Sipariş Durumu Ayarları',
    description: 'Herhangi bir sipariş durumunu yeniden adlandırın, renklendirin veya gizleyin. Gizli bir durum; yönetici, müşteri web sitesi ve mobil uygulama genelindeki durum seçicilerinden, filtrelerden ve gezinmeden kaybolur — temel durum mantığı (geçişler, iadeler vb.) her iki durumda da değişmeden çalışmaya devam eder.',
    displayNameEnColumn: 'Görünen Ad (EN)',
    displayNameArColumn: 'Görünen Ad (AR)',
    displayNameKuColumn: 'Görünen Ad (KU)',
    displayNameTrColumn: 'Görünen Ad (TR)',
    visibleColumn: 'Görünür',
    egNewOrderPlaceholder: 'ör. Yeni Sipariş',
    failedToSaveOneOrMoreStatuses: 'Bir veya daha fazla durum kaydedilemedi'
  },
  changeOrderStatus: {
    title: 'Sipariş Durumunu Değiştir',
    ordersSelectedSuffix: 'sipariş seçildi',
    orderColonPrefix: 'Sipariş:',
    alreadyPurchasedBeforeInfo: 'Bu sipariş daha önce satın alınmıştı — doğrudan Satın Alındı durumuna geri taşınacak, bu bilgileri tekrar girmenize gerek yok.',
    actualPriceCalculatedAutomatically: 'Gerçek fiyat her sipariş için otomatik olarak hesaplanacaktır.',
    refundReasonRequiredLabel: 'İade Nedeni*',
    moneyAmountLabel: 'Para Miktarı',
    eachOrderRefundedFullRemaining: 'Her sipariş için kalan tüm tutar iade edilecektir.',
    savingLabel: 'Kaydediliyor...',
    unmarkOrdersAsClearedConfirm: '{count} siparişin temizlendi işareti kaldırılsın mı? Aktif filtresi altında bu listede yeniden görünecekler.',
    orderAlreadyHasInvoiceMessage: '{orderId} siparişinin zaten {status} bir faturası var{invoiceNumber}. Devam etmek müşteriden tekrar ücret almaz. Devam edilsin mi?',
    ordersAlreadyHaveInvoiceMessage: 'Aşağıdaki siparişlerin zaten ödenmiş veya kısmen ödenmiş bir faturası var:\n\n{lines}\n\nDevam etmek onlardan tekrar ücret almaz. Devam edilsin mi?',
    orderAlreadyPurchasedRefundWarning: 'Bu sipariş zaten satın alındı/gönderildi. İptal edilmesi ayrıca müşteriye ${amount} tutarına kadar otomatik tam iade yapılmasını sağlayacaktır.',
    statusLockedOrderCanceled: 'Durum kilitli — sipariş iptal edildi',
    clickToChangeStatus: 'Durumu değiştirmek için tıklayın',
    failedToChangeOrderStatus: 'Sipariş durumu değiştirilemedi',
    ordersUpdatedSuccessfully: 'Siparişler başarıyla güncellendi'
  },
  shipOnly: {
    orderNoteColumn: 'Sipariş Notu',
    whDateColumn: 'Depo Tarihi',
    warehousePassedLabel: 'Depo Tarihi Geçti',
    warehouseDateChangedSuccessfully: 'Depo tarihi değiştirildi',
    orderPriceLabel: 'Sipariş fiyatı',
    willPayOption: 'Ödeyecek',
    loanOption: 'Borç',
    allOrdersApprovedAndPurchased: 'Seçilen tüm siparişler onaylandı ve satın alındı.',
    goToCustomerCreditLink: 'Müşteri kredisine git',
    addShipOnlyTitle: 'SADECE GÖNDERİ EKLE'
  },
  activityLog: {
    accountTypeLabel: 'Hesap türü',
    allAccountsOption: 'Tüm hesaplar',
    allPlatformsOption: 'Tüm platformlar',
    adminWebOption: 'Yönetim (web)',
    mobileIosOption: 'Mobil (iOS)',
    mobileAndroidOption: 'Mobil (Android)',
    accountNameLabel: 'Hesap (isim)',
    searchStaffOrCustomerPlaceholder: 'Personel veya müşteri adı ara',
    eventLabel: 'Olay',
    eventPlaceholder: 'ör. post, approved, login',
    subjectTypeLabel: 'Konu türü',
    subjectTypePlaceholder: 'ör. Order, Invoice',
    routeOrDescriptionPlaceholder: 'Rota veya açıklama',
    showingHistoryForPrefix: 'Şunun için geçmiş gösteriliyor:',
    accountColumn: 'Hesap',
    guestLabel: 'Misafir'
  },
  customerDeviceIcon: {
    orderedViaMobileApp: 'Mobil Uygulama ile Sipariş Edildi',
    orderedViaWeb: 'Web Üzerinden Sipariş Edildi',
    addedByAdminStaff: 'Yönetici/Personel Tarafından Eklendi',
    unknownSourceLegacyOrder: 'Bilinmeyen kaynak (eski sipariş)'
  },
  editBank: {
    title: 'Bankayı Düzenle',
    loadingBanks: 'Bankalar yükleniyor...',
    selectBankLabel: 'Banka Seç'
  },
  editEntityField: {
    editTypeTitle: 'Türü Düzenle',
    typeUpdatedSuccessfully: 'Tür başarıyla güncellendi',
    editSizeTitle: 'Boyutu Düzenle',
    sizeUpdatedSuccessfully: 'Boyut başarıyla güncellendi',
    editColorTitle: 'Rengi Düzenle',
    colorUpdatedSuccessfully: 'Renk başarıyla güncellendi'
  },
  editPriceForCountry: {
    priceUpdatedSuccessfully: 'Fiyat başarıyla güncellendi',
    pricePerWeightTurkeyLabel: 'Türkiye için ağırlık başına fiyat',
    pricePerWeightUsaLabel: 'ABD için ağırlık başına fiyat'
  },
  editQuantity: {
    title: 'Miktarı Düzenle',
    updatedSuccessfully: 'Miktar başarıyla güncellendi'
  },
  editQuantityCharge: {
    usaOtherLabel: 'ABD Diğer Miktar Ücreti',
    usaOtherUpdatedSuccessfully: 'ABD Diğer Miktar Ücreti başarıyla güncellendi',
    turkeyOtherLabel: 'Türkiye Diğer Miktar Ücreti',
    turkeyOtherUpdatedSuccessfully: 'Türkiye Diğer Miktar Ücreti başarıyla güncellendi',
    usaBaseLabel: 'ABD Temel Miktar Ücreti',
    usaBaseUpdatedSuccessfully: 'ABD Temel Miktar Ücreti başarıyla güncellendi',
    turkeyBaseLabel: 'Türkiye Temel Miktar Ücreti',
    turkeyBaseUpdatedSuccessfully: 'Türkiye Temel Miktar Ücreti başarıyla güncellendi'
  },
  giveToCustomer: {
    title: 'Yüzdeyi Düzenle',
    givenSuccessfully: 'Kupon müşteriye başarıyla verildi',
    giveButton: 'Ver'
  },
  editProductUrl: {
    title: 'Ürün Bağlantısını Düzenle',
    updatedSuccessfully: 'Ürün bağlantısı başarıyla güncellendi'
  },
  addRefundNumber: {
    title: 'İade Numarası Ekle',
    addedSuccessfully: 'İade numarası başarıyla eklendi'
  },
  mobileDatatable: {
    infoAndDateColumn: 'Bilgi ve Tarih',
    staffDetailColumn: 'Personel Detayı',
    infoAndStatusColumn: 'Bilgi ve Durum',
    customerDetailColumn: 'Müşteri Detayı',
    invoiceDetailColumn: 'Fatura Detayı',
    actionAndDateColumn: 'İşlem ve Tarih',
    couponDetailColumn: 'Kupon Detayı',
    statusAndDatesColumn: 'Durum ve Tarihler',
    customerAndDateColumn: 'Müşteri ve Tarih',
    staffAndCustomerColumn: 'Personel ve Müşteri',
    statusAndDateColumn: 'Durum ve Tarih',
    rateDetailColumn: 'Kur Detayı',
    dateAndActionsColumn: 'Tarih ve İşlemler'
  },
  shippingPrices: {
    title: 'Kargo Fiyatları (Türkiye)',
    updatedSuccessfully: 'Kargo fiyatları başarıyla güncellendi',
    pleaseUpdateAnythingError: 'Lütfen bir şey güncelleyin',
    addTypeButton: 'Tür Ekle'
  },
  phoneInput: {
    searchCountryLabel: 'Ülke ara',
    noMatches: 'Sonuç bulunamadı',
    phoneRequiredError: 'Telefon numarası gereklidir',
    phoneNotCorrectError: 'Telefon numarası doğru değil'
  },
  orderImage: {
    title: 'Sipariş Görseli',
    openCameraButton: 'Kamerayı Aç',
    closeCameraButton: 'Kamerayı Kapat',
    flipCameraButton: 'Kamerayı Çevir',
    downloadLink: 'İndir',
    cameraNotSupportedError: 'Tarayıcı desteklemiyor olabilir veya bir hata oluştu.',
    imageSavedMessage: 'Görsel Kaydedildi'
  },
  logs: {
    cashBackInvoiceTitle: 'Nakit İade Faturası',
    exRateLabel: 'Kur',
    failedToMergeSelectedInvoices: 'Seçilen faturalar birleştirilemedi.',
    receiptLabel: 'Makbuz',
    creditInvoiceNumber: 'Kredi Fatura Numarası',
    customerAddress: 'Müşteri Adresi',
    customerTel: 'Müşteri Telefonu',
    oldAmount: 'Eski Tutar',
    newAmount: 'Yeni Tutar',
    totalIqdLabel: 'Toplam IQD',
    refundInvoiceTitle: 'İade Faturası',
    shoppingOnlineInvoiceTitle: 'Online Alışveriş Faturası',
    orderNumberColon: 'Sipariş #:',
    itemColumn: 'Ürün',
    refundReasonPrefix: 'İade —',
    deliveryPriceColon: 'Teslimat Fiyatı:',
    deliveryColon: 'Teslimat:',
    shipZoneFeeColon: 'ShipZone Ücreti:',
    deliveryIraqiPriceColon: 'Irak Dinarı Teslimat Fiyatı:',
    phoneColon: 'Telefon:',
    emailColon: 'E-posta:',
    signatureLabel: 'İmza: _______________________________',
    orderNoColumn: 'Sipariş No.',
    remainColumn: 'Kalan',
    subTotalLabel: 'Ara Toplam:',
    totalPaidLabel: 'Toplam Ödenen:',
    totalRemainingLabel: 'Toplam Kalan:',
    totalReceivedLabel: 'Toplam Alınan:',
    totalRemainLabel: 'Toplam Kalan:'
  },
  whatsappTemplate: {
    sendWhatsappMessageLabel: 'Whatsapp Mesajı Gönder',
    englishMessageLabel: 'İngilizce Mesaj',
    arabicMessageLabel: 'Arapça Mesaj',
    kurdishMessageLabel: 'Kürtçe Mesaj',
    saveAsDefaultTemplateButton: 'Varsayılan Şablon Olarak Kaydet',
    deliverToBranchTitle: 'Şubeye Teslim Et',
    sendAllToBranchTitle: 'Tümünü Şubeye Gönder',
    templateSavedSuccessfully: 'Şablon başarıyla kaydedildi',
    failedToSaveTemplate: 'Şablon kaydedilemedi'
  },
  orderLog: {
    yourStaffLabel: 'personeliniz',
    yourCustomerLabel: 'müşteriniz',
    requestedVerb: 'talep etti',
    theOrderConnector: 'siparişi',
    deliveredTheOrderLabel: 'siparişi teslim etti',
    toConnector: '-e',
    shippedVerb: 'gönderdi',
    processedVerb: 'işledi',
    canceledVerb: 'iptal etti',
    approvedVerb: 'onayladı',
    refundedVerb: 'iade etti',
    purchasedVerb: 'satın aldı',
    sentToBranchVerb: 'şubeye gönderdi',
    atConnector: 'tarihinde'
  }
}



// WEBPACK FOOTER //
// ./src/lang/tr.js